<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-evaluation-new-form">
    <div v-if="showLockedModal" class="locked-modal-wrapper">
      <div class="modal-body">
        <div>
          <h3>This form is currently being edited</h3>
          <div class="text email">
            The following user is already editing this form:
            {{ capitalizeFirstLetter(formData.lockedBy) }}
          </div>
          <div class="text confirm">
            Are you sure you wish to proceed with your changes?
          </div>
        </div>
        <div class="btn-wrapper">
          <el-button :loading="isLockLoading" @click="handleLockForm"
            >CONTINUE ANYWAYS</el-button
          >
          <el-button :disabled="isLockLoading" @click="handleBtnViewOnly"
            >OPEN VIEW ONLY</el-button
          >
          <el-button
            :disabled="isLockLoading"
            class="cancel"
            @click="handleBtnClose"
            >CANCEL</el-button
          >
        </div>
      </div>
    </div>

    <!-- <el-form :disabled="mode==='view'" :class="{'read-only':mode==='view'}"> -->
    <el-container
      :disabled="mode === 'view'"
      :class="{ 'read-only': mode === 'view' }"
    >
      <div
        class="wy-evaluation-form-content"
        ref="sections"
        v-loading="loading"
      >
        <div v-if="!loading" class="new-form-header">
          <el-input
            class="text-input form-name"
            placeholder="Form name - Unpublished"
            :maxlength="maxCharacterFormName"
            :disabled="loading || mode === 'view'"
            v-model="formData.name"
            @focus="isFormNameEditing = true"
            @blur="isFormNameEditing = false"
          ></el-input>
          <div
            class="form-name-label"
            :class="{ disabled: loading || mode === 'view' }"
          >
            Form name<span style="color:red;">*</span>
          </div>
          <div
            v-if="
              isFormNameEditing && formData.name.length === maxCharacterFormName
            "
            class="warning-msg"
          >
            0 characters remains
          </div>
          <div
            v-if="
              isFormNameEditing && formData.name.length < maxCharacterFormName
            "
            class="reminding-msg"
          >
            {{ maxCharacterFormName - formData.name.length }} characters remains
          </div>
          <div v-if="mode === 'edit' || mode === 'new'" class="status-editable">
            Status: Editable
          </div>
          <div
            v-if="mode === 'view' && formData.status === 'published'"
            class="status-published"
          >
            Status: Published
          </div>
          <div
            v-if="mode === 'view' && formData.status === 'archived'"
            class="status-published"
          >
            Status: Archived
          </div>
          <div class="button-section">
            <button
              v-if="mode === 'edit'"
              class="btn-delete"
              @click="handleDeleteForm"
            >
              DELETE
            </button>
            <button
              v-if="mode === 'new' || mode === 'edit'"
              class="btn-publish"
              :disabled="disablePublish"
              @click="handlePublishForm"
            >
              PUBLISH
            </button>
            <button
              v-if="mode === 'new' || mode === 'edit'"
              class="btn-save-draft"
              :disabled="disableSaveDraft"
              @click="handleSaveForm"
            >
              SAVE DRAFT
            </button>
            <button
              v-if="
                mode === 'view' &&
                  formData.status === 'published' &&
                  inTask === 'No'
              "
              class="btn-save-draft"
              @click="handleArchiveForm"
            >
              ARCHIVE
            </button>
            <span
              class="btn-close el-icon-close"
              @click="handleBtnClose"
            ></span>
          </div>
        </div>
        <div class="new-form-body" :class="{ 'read-only': mode === 'view' }">
          <div class="div-form-description-title">Form description <span style="font-size: 14px; font-weight: 400;">(optional)</span>
            <el-tooltip
              popper-class="wy-evaluation-form-editor-form-description-popper"
              placement="bottom-start"
              :content="formDescriptionTooltip"
            >
              <i class="form_info"></i>
            </el-tooltip>
          </div>
          <el-input
            v-if="!loading"
            class="text-input form-description"
            :placeholder= "formDescriptionPlaceholder"
            :maxlength="maxCharacterFormDes"
            v-model="formData.description"
            @focus="isFormDesEditing = true"
            @blur="isFormDesEditing = false"
            :readonly="mode==='view'"
            type="textarea"
            resize="none"
          ></el-input>
          <div class="form-description-label">Description</div>
          <div v-if="(mode==='new'||mode==='edit') && isFormDesEditing && formData.description.length === maxCharacterFormDes" class="form-des-warning-msg">
            0 characters remains
          </div>
          <div v-if="(mode==='new'||mode==='edit') && isFormDesEditing && formData.description.length < maxCharacterFormDes" class="form-des-reminding-msg">
            {{ maxCharacterFormDes - formData.description.length }} characters remains
          </div>
          <div
            v-if="mode === 'edit' || mode === 'view'"
            class="form-history-records"
          >
            <div class="author-info-title">Author information</div>
            <div class="author-info-des">
              This tells you who created and last updated the evaluation form.
            </div>
            <div class="createdBy-updatedBy">
              <div class="createdBy">
                <div class="createdBy-label">CREATED BY</div>
                <div class="createdBy-des">{{ formData.creator }}</div>
              </div>
              <div class="updatedBy">
                <div class="updatedBy-label">LAST UPDATED BY</div>
                <div class="updatedBy-des">{{ formData.updater }}</div>
              </div>
            </div>
          </div>
          <div v-if="!loading" class="section-question">
            <div class="title">Form: Target score</div>
            <el-checkbox
              v-model="formData.targetEnabled"
              @change="handleTargetEnabledChange"
              >Enable Target Score
            </el-checkbox>
            <div class="div-form-target" :class="{'disabled': !formData.targetEnabled}" :disabled="!formData.targetEnabled">
              <div class="description"> Use the sliders to set the scoring range for agent performance for the whole form.  Something about how this includes scores from each section added below.</div>
              <div class="slider">
                <div class="slider-block">
                  <div class="target-start">0%</div>
                  <div class="target-end">100%</div>
                  <div ref="b1" style="top: 0px;" class="sphere button1"><div class="text-value">{{ formData.targetScoringStart }}</div></div>
                  <div ref="b1" style="top: 0px;" class="sphere button2"><div class="text-value">{{ formData.targetScoringEnd }}</div></div>
                  <div ref="t1" style="top: 0px;" class="target_2"></div>
                  <el-slider
                    ref="targetRangeSlider"
                    v-model="targetRange"
                    range
                    @input="targetRangeChange($refs.targetRangeSlider, $event)"
                    :show-tooltip="false"
                    :min="0"
                    :max="100">
                  </el-slider>
                </div>
              </div>
              
              <div class="target-title">Customize the name of your scoring ranges:</div>
              <div class="target-des">
                <div class="target-item">
                    <span class="value">0-{{ formData.targetScoringStart }}%</span>
                    <el-input
                      class="text-input form-target"
                      :class="{'empty': targetScoringRange1 === ''}"
                      type="text"
                      placeholder="Please input"
                      maxlength="40"
                      show-word-limit
                      @input="handleTargetScoringRangeChange"
                      v-model="targetScoringRange1"
                    ></el-input>
                </div> 
              </div>
              <div class="target-des">
                <div class="target-item">
                    <span class="value">{{formData.targetScoringStart}}-{{formData.targetScoringEnd}}%</span>
                    <el-input
                      class="text-input form-target"
                      :class="{'empty': targetScoringRange2 === ''}"
                      type="text"
                      placeholder="Please input"
                      maxlength="40"
                      show-word-limit
                      @input="handleTargetScoringRangeChange"
                      v-model="targetScoringRange2"
                    ></el-input>
                </div> 
              </div>
              <div class="target-des">
                <div class="target-item">
                  <span class="value">{{formData.targetScoringEnd}}-100%</span>
                    <el-input
                      class="text-input form-target"
                      :class="{'empty': targetScoringRange3 === ''}"
                      type="text"
                      placeholder="Please input"
                      maxlength="40"
                      show-word-limit
                      @input="handleTargetScoringRangeChange"
                      v-model="targetScoringRange3"
                    ></el-input>
                </div> 
              </div>
              <div class="target-title">To show the name of your scoring range on the evaluation form, check the box below. If you want to hide it, uncheck the box.</div>
              <el-checkbox
                v-model="formData.showTargetRange"
                @change="handleShowTargetRangeChange"
                >Show performance range name on evaluation
              </el-checkbox>
            
            </div>
            
            <div class="title">Manually set sections and questions weights</div>
            <div class="description">
              If you want to manage section and question weighting manually,
              check this box.
            </div>
            <div class="sub_description">Please note: Each form can include up to 5 sections, with a maximum of 5 questions per section</div>
            <el-checkbox
              v-model="formData.manualWeighting"
              @change="handleFormWeightChange"
              >Manual Weighting
            </el-checkbox>
            <div
              class="sections"
              v-if="formData.sections && formData.sections.length > 0"
            >
              <div
                :ref="'section' + sectionIndex"
                class="section-body"
                v-for="(section, sectionIndex) in formData.sections"
                :key="sectionIndex"
              >
                <div class="section-header">
                  <button
                    v-if="mode !== 'view'"
                    class="btn-move-section up"
                    :disabled="sectionIndex === 0"
                    @click="
                      moveSectionUp(
                        sectionIndex,
                        formData.sections,
                        $refs['section' + (sectionIndex - 1)]
                      )
                    "
                  >
                    <i class="el-icon-arrow-up"></i>
                  </button>
                  <button
                    v-if="mode !== 'view'"
                    class="btn-move-section down"
                    :disabled="sectionIndex === formData.sections.length - 1"
                    @click="
                      moveSectionDown(
                        sectionIndex,
                        formData.sections,
                        $refs['section' + (sectionIndex + 1)]
                      )
                    "
                  >
                    <i class="el-icon-arrow-down"></i>
                  </button>
                  <div v-if="mode === 'view'" class="section-blank-space">
                    &nbsp;
                  </div>
                  <div class="section-name">
                    <span v-if="!section.isEditMode" class="span-input-label" :class="{'duplicate-section-name':sectionNameDuplicate(section)}" @click="handleSectionFocus('editPencil'+sectionIndex, section, section.name)">{{ section.name }}<i v-if="mode!=='view'" class="el-icon-edit"></i></span>
                    <el-input v-if="section.isEditMode" :ref="'editPencil'+sectionIndex" :maxlength="maxCharacterSection" 
                    class="text-input" :class="{'duplicate-section-name':sectionNameDuplicate(section)}" placeholder="Please input" 
                    v-model="section.name" @blur="handleSectionBlur(section, section.name.trim())" @input="sanitizeInput(section)"></el-input>
                  </div>
                  <div class="section-weight-div">
                    <vue-numeric
                      v-if="formData.manualWeighting"
                      class="vue-numeric input-section-weight"
                      placeholder=""
                      v-model="section.weight"
                      v-bind:minus="false"
                      v-bind:precision="2"
                      v-bind:min="0.00"
                      :class="{ 'no-value': section.weight == '' }"
                      v-bind:max="100.00"
                      @keypress.native="handlePressNumbericAndPeriod"
                    ></vue-numeric>
                    <div
                      v-if="formData.manualWeighting"
                      class="section-weight-label"
                    >
                      Section weight % *
                    </div>
                    <div
                      v-if="formData.manualWeighting"
                      class="section-weight-label-background"
                      :class="{ 'no-value': section.weight == '' }"
                    ></div>
                  </div>
                  <div class="section-target-div">
                    <vue-numeric
                      class="vue-numeric input-section-target"
                      placeholder=""
                      v-model="section.target"
                      v-bind:minus="false"
                      v-bind:precision="0"
                      v-bind:min="0"
                      v-bind:max="100"
                      @keypress.native="handlePress"
                    ></vue-numeric>
                    <div
                      class="section-target-label"
                    >
                      Section target %
                    </div>
                    <div
                      class="section-target-label-background"
                    ></div>
                  </div>
                  <el-dropdown
                    v-if="mode !== 'view'"
                    ref="sectionPopupMenu"
                    trigger="click"
                    placement="bottom-start"
                  >
                    <span class="el-dropdown-link">
                      <i class="el-icon-three-dots"></i>
                    </span>
                    <el-dropdown-menu
                      slot="dropdown"
                      class="elv-form-question-menu"
                    >
                      <el-dropdown-item
                        @click.native="
                          removeSection(formData.sections, sectionIndex)
                        "
                        >DELETE SECTION</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                  <div
                    v-if="
                      section.isEditMode &&
                        section.name.length === maxCharacterSection
                    "
                    class="warning-msg"
                  >
                    0 characters remains
                  </div>
                  <div v-else-if="section.isEditMode" class="reminding-msg">
                    {{ maxCharacterSection - section.name.length }} characters
                    remains
                  </div>
                </div>
                <div class="section-content">
                  <div class="questions" v-if="section.questions.length > 0">
                    <div
                      :id="question.uiQuestionId"
                      :ref="
                        'section' + sectionIndex + 'question' + questionIndex
                      "
                      class="question-body"
                      v-for="(question, questionIndex) in section.questions"
                      :key="questionIndex"
                    >
                      <div class="gotoCustomQuestion" v-if="isRoleAllow(4707) && (isCustomQuestion(question)||question.isCustomCategory)">
                        <span>Need to create a new question? You can do that in the <span class="go-to-custom-question-link" @click="gotoCustomQuestion()">Question editor</span></span>
                      </div>
                      <div class="question-header">
                        <button
                          v-if="mode !== 'view'"
                          class="btn-move-question up"
                          :disabled="questionIndex === 0"
                          @click="
                            moveSectionUp(
                              questionIndex,
                              section.questions,
                              $refs[
                                'section' +
                                  sectionIndex +
                                  'question' +
                                  (questionIndex - 1)
                              ]
                            )
                          "
                        >
                          <i class="el-icon-arrow-up"></i>
                        </button>
                        <button
                          v-if="mode !== 'view'"
                          class="btn-move-question down"
                          :disabled="
                            questionIndex === section.questions.length - 1
                          "
                          @click="
                            moveSectionDown(
                              questionIndex,
                              section.questions,
                              $refs[
                                'section' +
                                  sectionIndex +
                                  'question' +
                                  (questionIndex + 1)
                              ]
                            )
                          "
                        >
                          <i class="el-icon-arrow-down"></i>
                        </button>
                        <div
                          v-if="mode === 'view'"
                          class="question-blank-space"
                        >
                          &nbsp;
                        </div>
                        <div
                          v-if="categoryQuestions.length > 0"
                          class="category-question-section"
                        >
                          <el-select
                            ref="categoryDropdown"
                            v-model="question.uiCategoryId"
                            @change="categoryChanged($event, question)"
                            collapse-tags
                            size="mini"
                            class="category-dropdown"
                            :disabled="mode === 'view'"
                            :class="{ 'no-value': !question.uiCategoryId }"
                            popper-class="wy-auto-qa-elv-form-category-questions"
                            placeholder=""
                          >
                            <el-option
                              v-for="item in categoryQuestions"
                              :key="item.libraryCategoryId"
                              :label="item.categoryName"
                              :value="item.libraryCategoryId"
                              :disabled="disabledCategory(item)"
                            >
                            </el-option>
                          </el-select>
                          <div v-if="isPhraseMatchQuestion(question)" class="phrase-match-question-text">
                            <el-input
                              v-model="question.text"
                              placeholder="Enter phrase"
                              class="phrase-input"
                              :class="{ 'no-value': question.text==null || question.text==='' }"
                              :disabled="mode === 'view'"
                              :maxlength="maxCharacterQuestionName"
                              @focus="isQuestionEditing = true"
                              @blur="isQuestionEditing = false"
                            ></el-input>
                            <div v-if="isQuestionEditing&&question.text&&question.text.length===maxCharacterQuestionName" class="warning-msg">
                              0 characters remains
                            </div>
                            <div v-if="isQuestionEditing&&question.text&&question.text.length<maxCharacterQuestionName" class="reminding-msg">
                              {{ maxCharacterQuestionName - question.text.length }} characters remains
                            </div>
                          </div>
                          <!-- <el-select
                            v-else-if="isCustomQuestion(question)"
                            ref="questionDropdown"
                            v-model="question.libraryQuestionId"
                            @change="questionChanged($event, question)"
                            placeholder=""
                            collapse-tags
                            size="mini"
                            class="question-dropdown"
                            :class="{ 'no-value': !question.libraryQuestionId }"
                            popper-class="wy-auto-qa-elv-form-category-questions questions"
                            :disabled="
                              mode === 'view' || question.uiCategoryId == null
                            "
                          >
                            <el-option
                              v-for="item in customQuestionList"
                              :key="item.questionId"
                              :label="item.questionName"
                              :value="item.questionId"
                              :disabled="item.disabled"
                            >
                            </el-option>
                          </el-select> -->
                          <el-select
                            v-else
                            ref="questionDropdown"
                            v-model="question.libraryQuestionId"
                            @change="questionChanged($event, question)"
                            placeholder=""
                            filterable
                            collapse-tags
                            size="mini"
                            class="question-dropdown"
                            :class="{ 'no-value': !question.libraryQuestionId }"
                            popper-class="wy-auto-qa-elv-form-category-questions questions"
                            :disabled="
                              mode === 'view' || question.uiCategoryId == null
                            "
                          >
                            <el-option
                              v-for="item in getQuestionList(
                                question.uiCategoryId
                              )"
                              :key="item.libraryQuestionId"
                              :label="item.libraryQuestionText"
                              :value="item.libraryQuestionId"
                              :disabled="item.disabled"
                            >
                            </el-option>
                          </el-select>
                          
                          <vue-numeric
                            v-if="formData.manualWeighting"
                            class="vue-numeric input-question-weight"
                            placeholder=""
                            :disabled="
                              question.uiCategoryId == null ||
                                question.text == null
                            "
                            v-model="question.weight"
                            v-bind:minus="false"
                            v-bind:precision="2"
                            v-bind:min="0.00"
                            :class="{ 'no-value': question.weight == '' }"
                            v-bind:max="100.00"
                            @keypress.native="handlePressNumbericAndPeriod"
                          >
                          </vue-numeric>
                          <div
                            v-if="formData.manualWeighting"
                            class="question-weight-label"
                          >
                            Question weight % *
                          </div>
                          <div
                            v-if="formData.manualWeighting"
                            class="question-weight-label-background"
                            :class="{
                              disabled:
                                question.uiCategoryId == null ||
                                question.text == null,
                              'no-value': question.weight == '',
                            }"
                          ></div>
                          <el-dropdown
                            v-if="mode !== 'view'"
                            ref="questionPopupMenu"
                            trigger="click"
                            placement="bottom-start"
                            @command="
                              moveQuestion(
                                $event,
                                questionIndex,
                                section,
                                question
                              )
                            "
                          >
                            <span class="el-dropdown-link">
                              <i class="el-icon-three-dots"></i>
                            </span>
                            <el-dropdown-menu
                              slot="dropdown"
                              class="elv-form-question-menu"
                            >
                              <el-dropdown-item
                                @click.native="
                                  removeQuestion(
                                    section.questions,
                                    questionIndex
                                  )
                                "
                                >DELETE QUESTIONS</el-dropdown-item
                              >
                              <el-dropdown-item
                                v-for="section in getAvailableSections(
                                  sectionIndex
                                )"
                                :key="section.uiSectionId"
                                :value="section.uiSectionId"
                                :command="section.uiSectionId"
                                >MOVE TO {{ section.name }}</el-dropdown-item
                              >
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                        <span class="category-title">Question category</span>
                        <span class="question-title">Question</span>
                      </div>
                      <div class="question-content" :class="{ 'read-only': mode === 'view' }">
                        <div>
                          <el-input
                            v-if="isCustomQuestion(question)"
                            class="text-input question-description"
                            :class="{ 'no-value': !question.description == null || question.description == '' }"
                            :maxlength="maxCharacterDes"
                            placeholder="Description"
                            disabled
                            v-model="question.description"
                            @focus="handleQuestionDesFocus(question)"
                            @blur="handleQuestionDesBlur(question)"
                            readonly
                            type="textarea"
                            resize="none"
                          ></el-input>
                          <el-input
                            v-else
                            class="text-input question-description"
                            :maxlength="maxCharacterDes"
                            placeholder="Description (optional)"
                            v-model="question.description"
                            @focus="handleQuestionDesFocus(question)"
                            @blur="handleQuestionDesBlur(question)"
                            :readonly="mode==='view'"
                            type="textarea"
                            resize="none"
                          ></el-input>
                        </div>
                        <div v-if="isCustomQuestion(question)" class="custom-question-description-label">
                          Question description <span>*</span>
                        </div>
                        <div v-else class="question-description-label">
                          Question description
                        </div>
                        <div v-if="isCustomQuestion(question)" 
                          class="custom-question-description-label-background"
                          :class="{ 'no-value': question.description == null || question.description == '','disabled': true }">
                        </div>
                        <div
                          v-if="(mode==='new'||mode==='edit') && 
                            question.editDes && question.description &&
                              question.description.length === maxCharacterDes
                          "
                          class="warning-msg"
                        >
                          0 characters remains
                        </div>
                        <div
                          v-if="(mode==='new'||mode==='edit') && 
                            question.editDes && !(question.description==null) &&
                              question.description.length<maxCharacterDes
                          "
                          class="reminding-msg"
                        >
                          {{ maxCharacterDes - question.description.length }}
                          characters remains
                        </div>
                        <WyAutoQAFormThresholdSection 
                          :category="getCategoryText(question.uiCategoryId)"
                          :question="question"
                          @handlepress-event="handlePress"/>
                          
                        <div v-if="isPhraseMatchQuestion(question)" class="phrase-match">
                        <!-- <div v-if="question.categoryText==='PHRASE_MATCH'" class="phrase-match"> -->
                          <div class="sub_description">Choose your match type and add phrases to be automatically matched and identified in conversations. They should match your question. </div>
                          <div class="div-phrase-match">
                            <div class="match-type">
                              <el-select
                                ref="questionDropdown"
                                v-model="question.libraryQuestionId"
                                @change="questionChanged($event, question)"
                                placeholder=""
                                collapse-tags
                                size="mini"
                                class="question-dropdown"
                                :class="{ 'no-value': !question.libraryQuestionId }"
                                popper-class="wy-auto-qa-elv-form-category-questions questions"
                                :disabled="
                                  mode === 'view' || question.uiCategoryId == null
                                "
                              >
                                <el-option
                                  v-for="item in getQuestionList(
                                    question.uiCategoryId
                                  )"
                                  :key="item.libraryQuestionId"
                                  :label="item.libraryQuestionText"
                                  :value="item.libraryQuestionId"
                                  :disabled="item.disabled"
                                >
                                </el-option>
                              </el-select>
                            </div>
                            <div class="sent-by">
                              <el-select v-model="question.phraseMatchSentBy" placeholder="Select" 
                                popper-class="wy-auto-qa-elv-form-questions-phrase-match-sent-by">
                                <el-option
                                  v-for="item in phraseMatchSentBy"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                            </div>
                            <span class="phrase-match-type-title">Match type</span>
                            <span class="phrase-match-sent-by-title">Sent by</span>
                            <!-- <div class="phrase-section">
                              <div v-for="(phraseMatch, phraseMatchIndex) in question.phraseMatchExamples" :key="phraseMatchIndex" class="phrase-match-body">
                                <el-input v-model="question.phraseMatchExamples[phraseMatchIndex]" placeholder="Enter phrase" class="phrase-input"></el-input>
                              </div>
                            </div> -->
                          </div>
                         
                          <div class="div-phrase-content">
                            <div class="phrase-examples">
                              <el-tag
                                v-for="(tag, index) in question.phraseMatchExamples"
                                :key="index"
                                closable
                                :class="{'duplicate-phrase':phraseMatchDuplicate(question, tag), 'phrase-match-tag-update':question.phraseUpdate&&index===question.selectedTagIndex, 'disabled':mode==='view'}"
                                :disable-transitions="false"
                                @click="handlePhraseClick(question,index)"
                                @close="handlePhaseClose(question,index)">
                                {{tag}}
                              </el-tag>
                              
                              <el-input
                                v-if="question.inputExampleVisible"
                                class="input-new-tag"
                                v-model="question.inputExampleValue"
                                ref="saveTagInput"
                                :maxlength="maxCharacterExamples"
                                show-word-limit
                                size="mini"
                                @keyup.native="handleInputKeyup($refs)"
                                @keyup.enter.native="handleInputConfirm(question)"
                                @blur="handleInputConfirm(question)"
                              >
                              </el-input>
                              <el-button v-else-if="(mode==='new'||mode==='edit')&&showAddExamplesBtn(question)" class="button-new-tag" size="small" @click="showInput(question)">+ New Example Phrase - make sure this matches your question</el-button>
                            </div>
                            <span class="phrase-match-title">Phrases</span>
                          </div>
                          <!-- <button class="btn-add-phrase" @click="addPhrase(question)">ADD PHRASE</button> -->
                        </div>
                        <div class="options-section" v-if="isCustomQuestion(question) && question.options.length>0">
                          <div class="sub_description black-info">Select the check box if you want to trigger a KPI failure for that answer. Then, select if it should automatically trigger a section or form failure.</div>
                          <div class="option-title" v-for="(option, optionIndex) in question.options" :key="option.optionKey">
                            <div v-if="isValidatedOption(option, question)" class="option-body">
                              <span class="option-label-title">option{{ optionIndex+1 }}</span>
                              <el-input class="option-label" v-model="option.label" disabled></el-input>
                              <span v-if="option.optionKey!=='na'" class="option-value-title">Percentage (%)</span>
                              <vue-numeric
                                v-if="option.optionKey!=='na'" 
                                class="vue-numeric option-value"
                                :class="{ 'no-value': (option.points!==0&&option.points=='')||allPointsAreZero(question.options) }"
                                placeholder=""
                                v-model="option.points"
                                v-bind:minus="false"
                                v-bind:precision="0"
                                v-bind:min="0"
                                v-bind:max="100"
                                :disabled="option.isKpi"
                                @keypress.native="handlePress"
                              ></vue-numeric>
                              <!-- <el-input v-if="option.optionKey!=='na'" class="option-value" v-model="option.points" :disabled="option.isKpi"></el-input> -->
                              <el-checkbox v-if="option.optionKey!=='na'" :disabled="!option.isKpi&&isKpiDisabled(question.options)" v-model="option.isKpi" @change="handleIsKPIChanged($event, option)">KPI failure</el-checkbox>
                              <div v-if="option.isKpi" class="option-kpi-section">
                                <span class="label">If KPI fails: </span>
                                <span class="option-auto-fail-title">Autofail</span>
                                <el-select v-model="option.autoFailLevel" placeholder="Select" @change="autoFailLevelChanged($event, option)"
                                 popper-class="wy-auto-qa-elv-form-questions-options-auto-fail-level">
                                  <el-option
                                    v-for="item in autoFailLevels"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="options-section" v-else-if="isPhraseMatchQuestion(question)&&question.options.length>0">
                          <div class="sub_description">Choose if the option is a KPI and then whether or not it should automatically fail a section or form. </div>
                          <div class="option-title" v-for="(option, optionIndex) in question.options" :key="option.optionKey">
                            <div v-if="isValidatedOption(option, question)" class="option-body">
                              <span class="option-label-title">option{{ optionIndex+1 }}</span>
                              <el-input class="option-label" v-model="option.label" disabled></el-input>
                              <span v-if="option.optionKey!=='na'" class="option-value-title">Percentage (%)</span>
                              <el-select v-model="option.points" class="phrase-match-option-dropdown option-value" placeholder="Select" 
                              popper-class="wy-evaluation-form-editor-phrase-match-option-dropdown-popper" @change="phraseMatchOptionPointsChanged($event, option, question)">
                                <el-option
                                  v-for="item in phraseMatchOptionPoints"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                              <el-checkbox v-if="option.points==0" v-model="option.isKpi" @change="handleIsKPIChangedPhraseMatch($event, option)">KPI failure</el-checkbox>
                              <div v-if="option.isKpi" class="option-kpi-section">
                                <span class="label">If KPI fails: </span>
                                <span class="option-auto-fail-title">Autofail</span>
                                <el-select v-model="option.autoFailLevel" placeholder="Select" @change="autoFailLevelChanged($event, option)"
                                 popper-class="wy-auto-qa-elv-form-questions-options-auto-fail-level">
                                  <el-option
                                    v-for="item in autoFailLevels"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="options-section" v-else-if="question.options.length>0">
                          <div class="sub_description">Choose if the option is a KPI and then whether or not it should automatically fail a section or form. </div>
                          <div class="option-title" v-for="(option, optionIndex) in question.options" :key="option.optionKey">
                            <div v-if="isValidatedOption(option, question)" class="option-body">
                              <span class="option-label-title">option{{ optionIndex+1 }}</span>
                              <el-input class="option-label" v-model="option.label" disabled></el-input>
                              <span v-if="option.optionKey!=='na'" class="option-value-title">Percentage (%)</span>
                              <el-input v-if="option.points!=-1" class="option-value" v-model="option.points" disabled></el-input>
                              <el-checkbox v-if="option.points===0" v-model="option.isKpi" @change="handleIsKPIChanged($event, option)">KPI failure</el-checkbox>
                              <div v-if="option.isKpi" class="option-kpi-section">
                                <span class="label">If KPI fails: </span>
                                <span class="option-auto-fail-title">Autofail</span>
                                <el-select v-model="option.autoFailLevel" placeholder="Select" @change="autoFailLevelChanged($event, option)"
                                 popper-class="wy-auto-qa-elv-form-questions-options-auto-fail-level">
                                  <el-option
                                    v-for="item in autoFailLevels"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="answer-content">
                          <div>
                            Select an answer template or click the button below
                            to add an answer
                          </div>
                          <div class="div-add-answer-btn">
                            <button class="btn-add-answer">ADD ANSWER</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="mode !== 'view' && section.questions.length == 0"
                    class="add-question-title"
                  >
                    Please add a question to this section
                  </div>
                  <div
                    v-if="
                      mode !== 'view' &&
                        section.questions &&
                        section.questions.length < maxQuestions
                    "
                    class="div-add-question-btn"
                  >
                    <button
                      class="btn-add-question"
                      @click="newQuestion(section)"
                    >
                      ADD QUESTION
                    </button>
                  </div>
                  <div
                    v-if="
                      mode !== 'view' &&
                        formData.manualWeighting &&
                        section.questions.length > 0
                    "
                    class="div-balance-question-weight-btn"
                  >
                    <button
                      class="btn-balance-question-weight"
                      @click="balanceQuestionWeight(section)"
                    >
                      BALANCE QUESTION WEIGHT
                    </button>
                    <span
                      class="question-weight-percentage"
                      :class="{ red: sumWeight(section.questions) !== 100 }"
                    >
                    {{ (hasDecimal(sumWeight(section.questions))) 
                        ? sumWeight(section.questions).toFixed(2)
                        : sumWeight(section.questions) }} / 100%<i
                        class="el-icon-weight-info"
                      ></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="formData.sections && formData.sections.length == 0"
              class="add-section-title"
            >
              Please add a section
            </div>
            <div
              v-if="mode !== 'view' && formData.sections"
              class="div-add-section-btn"
            >
              <button
                v-if="
                  formData.sections && formData.sections.length < maxSections
                "
                class="btn-add-section"
                @click="newSection"
              >
                ADD SECTION
              </button>
              <button
                v-if="formData.manualWeighting && formData.sections.length > 0"
                class="btn-balance-section-weight"
                @click="balanceSectionWeight"
              >
                BALANCE SECTION WEIGHT
              </button>
              <span
                v-if="formData.manualWeighting && formData.sections.length > 0"
                class="section-weight-percentage"
                :class="{ red: sumWeight(formData.sections) !== 100 }"
              >
              {{ (hasDecimal(sumWeight(formData.sections))) 
                  ? sumWeight(formData.sections).toFixed(2)
                  : sumWeight(formData.sections) }} / 100%<i
                  class="el-icon-weight-info"
                ></i
              ></span>
            </div>
          </div>
          <div v-if="this.formData.additionalInstructions!==undefined" class="div-form-ai-evaluation-instructions">
            <div class="div-ai-evaluation-instructions-title">Additional AI Evaluation Instructions <span style="font-size: 14px; font-weight: 400;">(optional)</span>
              <el-tooltip
                popper-class="wy-evaluation-form-editor-form-description-popper"
                placement="bottom-start"
                :content="additionalInstructionsTooltip"
              >
                <i class="ai-evaluation-instructions_info"></i>
              </el-tooltip>
            </div>
            <div class="div-form-ai-evaluation-instructions">
              <el-input
                v-if="!loading"
                class="text-input ai-evaluation-instructions"
                :placeholder= "additionalInstructionsPlaceholder"
                :maxlength="maxCharacterAdditionalInstructions"
                v-model="formData.additionalInstructions"
                @focus="isAdditionalInstructions = true"
                @blur="isAdditionalInstructions = false"
                :readonly="mode==='view'"
                type="textarea"
                resize="none"
              ></el-input>
              <div class="ai-evaluation-instructions-label">Description</div>
              <div v-if="(mode==='new'||mode==='edit') && isAdditionalInstructions && formData.additionalInstructions.length === maxCharacterAdditionalInstructions" class="form-ai-evaluation-instructions-warning-msg">
                0 characters remains
              </div>
              <div v-if="(mode==='new'||mode==='edit') && isAdditionalInstructions && formData.additionalInstructions.length < maxCharacterAdditionalInstructions" class="form-ai-evaluation-instructions-reminding-msg">
                {{ maxCharacterAdditionalInstructions - formData.additionalInstructions.length }} characters remains
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
    <!-- </el-form> -->
    <wy-evaluation-preview
      v-if="!loading"
      :formData="formData"
      :categoryQuestions="categoryQuestions"
    />
    <div v-if="isPopupVisible" class="popup-wrapper">
      <div class="popup-body">
        <div class="title">Confirm</div>
        <div class="desc">{{ popupBodyText }}</div>
        <div class="footer">
          <el-button
            type="primary"
            size="mini"
            class="no-action"
            @click="isPopupVisible = false"
            >NO</el-button
          >
          <el-button type="primary" size="mini" @click="handlePopupConfirm"
            >YES</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueNumeric from "vue-numeric";
import WyEvaluationPreview from "./wy-evaluation-preview.vue";
import WyAutoQAFormThresholdSection from "./wy-auto-qa-form-threshold-section.vue";

export default {
  name: "wy-evaluation-new-form",
  modalTitle: null,
  modelContentStyle:
    "width: 100vw !important; max-width: unset !important; max-width: unset !important; height: 100vh; border-radius: 0px;",
  props: ["appVue", "formManager"],
  components: {
    VueNumeric,
    "wy-evaluation-preview": WyEvaluationPreview,
    WyAutoQAFormThresholdSection
  },
  data() {
    return {
      module: this,
      loading: true,
      formId: null,
      pageName: "formEditorPage",
      input: "",
      mode: "",
      inTask: "No",
      // weight: false,
      formList: [],
      libraryCategoryName: 'Custom',
      categoryQuestions: [],
      formListRef: null,
      popupBodyText: "",
      popupAction: "",
      isPopupVisible: false,
      isFormNameEditing: false,
      isFormDesEditing: false,
      isAdditionalInstructions: false,
      isQuestionEditing: false,
      showLockedModal: false,
      isLockLoading: false,
      prePositionB1 : 0,
      targetRange: [40, 60],
      targetScoringRange1: '',
      targetScoringRange2: '',
      targetScoringRange3: '',
      // targetLowValue: 0,
      // targetHighValue: 0,
      //conversation_duration
      // individual_hold_time
      // number_of_hold_events
      // total_silence_time

      // libraryOptionId
      // libraryOptionText
      // optionKey

      customerEffortOperator: ["<", "<="],
      thresholdOperatorMapping: {
        "<": "under",
        "<=": "under_or_equal",
      },
      autoFailLevels: [
        { id: 'form', name: 'Form' },
        { id: 'section', name: 'Section' },
      ],
      phraseMatchType: [
        { id: 'exactMatch', name: 'Exact Match' },
        { id: 'AiMatch', name: 'AI Match' },
      ],
      phraseMatchSentBy: [
        { id: 'AGENT', name: 'Agent' },
        { id: 'CUSTOMER', name: 'Customer' },
        { id: 'BOTH', name: 'Any' },
      ],
      // sections: [],
      sectionEditMode: {},
      internalSectionIdIncrease: 0,
      internalQuestionIdIncrease: 0,
      formData: {},
      cloneFormData: {},
      selectedQuestions: [],
      preMsgObj: null,
      maxSections: 5,
      maxQuestions: 5,
      dialogVisible: false,
      formDescriptionPlaceholder: "Your form description could include the following:\n\n • What industry does your contact center serve?\n • What lines of business do the agents handle?\n • What agent skills or behaviour is this form intended to evaluate?",
      formDescriptionTooltip: 'In Form Description, you can provide an overview of what the form is about and what it is intended to evaluate. This context will help the AI better understand the objective of the form to provide an improved evaluation.',
      additionalInstructionsPlaceholder: "You can include information such as:\n\n • Business terms or jargon commonly used in your contact center\n • Abbreviations and acronyms for your business processes\n • Any additional information about your organization or contact center",
      additionalInstructionsTooltip: 'In this field, you can provide additional context specific to your contact center that could be helpful in the evaluation process. This information will help the AI gain more knowledge to better understand your agent conversations.',
      maxCharacterFormName: 64,
      maxCharacterFormDes: 3000,
      maxCharacterAdditionalInstructions: 3000,
      maxCharacterSection: 64,
      maxCharacterDes: 1000,
      maxCharacterQuestionName: 500,
      maxCharacterExamples: 50,
      phraseMatchLimit: 5,
      phraseExactMatchExamplesLimit: 50,
      phraseAIMatchExamplesLimit: 10,

      customQuestionList: [],
      phraseMatchOptionPoints: [{
          value: 0,
          label: 0
        }, {
          value: 100,
          label: 100
        }
      ],
    };
  },
  computed: {
    ...mapGetters(["companyProfileSettings", "authUser", "isRoleAllow"]),

    disableSaveDraft() {
      return (
        this.disableUpdate ||
        this.noFormDataChanged ||
        !this.isValidatedSave ||
        this.loading
      );
    },

    disablePublish() {
      return (
        this.disableUpdate ||
        (this.formId === 0 && this.noFormDataChanged) ||
        !this.isValidatedSave ||
        this.loading
      );
    },

    disableUpdate() {
      if (this.formData.sections) {
        return (
          this.formData.name === "" ||
          this.formData.sections.length === 0 ||
          this.formData.name.length > 64 ||
          this.formData.description.length > this.maxCharacterFormDes
        );
      } else {
        return true;
      }
    },

    noFormDataChanged() {
      return (
        JSON.stringify(this.cloneFormData) === JSON.stringify(this.formData)
      );
    },

    isValidatedSave() {
      let isValid = true;
      if(this.formData.targetScoringRanges && this.formData.targetScoringRanges.length === 3) {
        if(this.formData.targetScoringRanges[0] === '' || this.formData.targetScoringRanges[1] === '' || this.formData.targetScoringRanges[2] === '') {
          isValid = false;
        }
      }
      if (this.formData.sections) {
        this.formData.sections.forEach((section) => {
          if (this.sectionNameDuplicate(section)) {
            isValid = false;
          }
          if (this.formData.manualWeighting && (typeof section.weight !== "number" || section.weight === 0)) {
            isValid = false;
          }
          section.questions.forEach((question) => {
            if (this.formData.manualWeighting && typeof question.weight !== "number") {
              isValid = false;
            }
            if (!question.uiCategoryId || !question.libraryQuestionId) {
              isValid = false;
            } else {
              if (question.questionType === "METADATA") {
                if (
                  question.thresholdOperator === "" ||
                  typeof question.thresholdValue !== "number"
                ) {
                  isValid = false;
                }
              }
            }
            if(question.text === '') {
              isValid = false;
            }
            if(this.isCustomQuestion(question)) {
              if(question.description === '') {
                isValid = false;
              }
            }
            // checkout options
            if(this.isCustomQuestion(question) && question.options.length > 0) {
              let totalPoints = 0;
              question.options.forEach((option) => {
                if(option.points === '') {
                  isValid = false;
                }
                if(option.optionKey !== 'na') {
                  totalPoints = totalPoints + parseInt(option.points);
                }
              })
              if(totalPoints === 0) {
                isValid = false;
              }
            }
          });
        });
      }
      return isValid;
    },
  },

  methods: {
    ...mapActions([
      "fetchCompanyProfileSettings",
      "fetchAutoQAEvalFormDropdown",
      "fetchAutoQAEvalQuestionList",
      "fetchAutoQAEvalFormById",
      "fetchAutoEvalFormList",
      "updateAutoEvalForm",
      "lockAutoEvalForm",
      "unlockAutoEvalForm",
      "fetchAutoCustomEvalQuestionList",
    ]),

    disabledCategory(item) {
      if(item.dropdownQuestions.filter((el) => el.questionType === "PHRASE_MATCH").length > 0) {
        return this.checkPhraseMatchLimit();
      }
      else if(item.libraryCategoryId != 999) {
        let arr = item.dropdownQuestions.filter((el) => !el.disabled);
        return arr.length === 0;
      }
      else {
        return false;
      }
    },

    handleTargetEnabledChange(targetEnabled) {
      if(targetEnabled) {
        this.targetRange = [40, 60];
        this.formData.targetScoringStart = this.targetRange[0];
        this.formData.targetScoringEnd = this.targetRange[1];
        this.formData = JSON.parse(JSON.stringify(this.formData))
      }
      else {
        this.targetRange = [0, 1];
        this.formData.targetScoringStart = this.targetRange[0];
        this.formData.targetScoringEnd = this.targetRange[1];
        this.formData = JSON.parse(JSON.stringify(this.formData))
      }
    },

    targetRangeChange(el) {
      setTimeout(() => {
        let b1 = document.querySelector(".sphere.button1");
        let b2 = document.querySelector(".sphere.button2");
        let t2 = document.querySelector(".target_2");
        b1.style.top = '50px'//(el.$refs.button1.$el.getBoundingClientRect().top - 86) + 'px'
        b1.style.left = 'calc(' + el.$refs.button1.$el.style.left + ' - 10px)';//(el.$refs.button1.$el.getBoundingClientRect().left - 45) + 'px'

        b2.style.top = '50px'//(el.$refs.button2.$el.getBoundingClientRect().top - 86) + 'px'
        b2.style.left ='calc(' + el.$refs.button2.$el.style.left + ' - 10px)';//(el.$refs.button2.$el.getBoundingClientRect().left - 45) + 'px'
        t2.style.top = '68px'//(el.$refs.button2.$el.getBoundingClientRect().top - 68) + 'px'
        t2.style.left = 'calc(' + el.$refs.button2.$el.style.left + ' - 6px)';//(el.$refs.button2.$el.getBoundingClientRect().left - 41) + 'px'
        
      }, 10);
      if(this.targetRange[0] === this.targetRange[1] && this.targetRange[0] < 100) {
        this.targetRange[1] ++;
      }
      else if(this.targetRange[0] === 100){
        this.targetRange[0] --;
      }
      this.formData.targetScoringStart = this.targetRange[0];
      this.formData.targetScoringEnd = this.targetRange[1];
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },

    handleTargetScoringRangeChange() {
      this.formData.targetScoringRanges = [this.targetScoringRange1, this.targetScoringRange2, this.targetScoringRange3];
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },

    handleShowTargetRangeChange() {
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },

    sanitizeInput(section) {
      section.name = section.name.replace(/['"]/g, '');
    },

    isValidatedOption(option, question) {
      return ((option.optionKey && ((option.optionKey === 'yes' || option.optionKey === 'no' || option.optionKey === 'na'))) || (this.isCustomQuestion(question))) ? true : false;
    },

    isEnableKPI(options, option) {
      let unSelectAll = true;
      options.forEach(item => {
        if(item.isKpi) {
          unSelectAll = false;
        } 
      })
      return unSelectAll || option.isKpi;
    },

    // isKpiDisabled(options) {
    //   let checkedKpi = false;
    //   options.forEach(item => {
    //     if(item.isKpi) {
    //       checkedKpi = true;
    //     } 
    //   })
    //   return checkedKpi;
    // },
    isKpiDisabled(options) {
      let unCheckedKpi = 0;
      options.forEach(item => {
        if(!item.isKpi && item.optionKey !== 'na') {
          unCheckedKpi ++;
        } 
      })
      return unCheckedKpi < 2;
    },

    allPointsAreZero(options) {
      let isAllZero = false;
      let totalPoints = 0;
      options.forEach((option) => {
        if(option.optionKey !== 'na') {
          totalPoints = totalPoints + parseInt(option.points);
        }
      })
      if(totalPoints === 0) {
        isAllZero = true;
      }
      return isAllZero;
    },

    phraseMatchOptionPointsChanged(val, option, question) {
      if(val === 0) {
        question.options.forEach((item) => {
          if(item.optionKey !== option.optionKey) {
            item.points = 100;
            item.isKpi = false;
          }
        })
      }
      if(val === 100) {
        question.options.forEach((item) => {
          if(item.optionKey !== option.optionKey) {
            item.points = 0;
            option.isKpi = false;
          }
        })
      }
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },

    handleIsKPIChanged(isKPI, option) {
      if(!isKPI) {
        option.autoFailLevel = null;
        option.points = option.libraryOptionPoints;
      } 
      else {
        option.autoFailLevel = 'form';
        option.points = 0;
      }
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },

    handleIsKPIChangedPhraseMatch(isKPI, option) {
      if(!isKPI) {
        option.autoFailLevel = null;
      } 
      else {
        option.autoFailLevel = 'form';
      }
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },

    autoFailLevelChanged(val, option) {
      if(val === 'form') {
        option.autoFailLevel = 'form';
      }
      else {
        option.autoFailLevel = 'section';
      }
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },

    sectionNameDuplicate(currentSection) {
      let duplicateName = false;
      this.formData.sections.forEach((section) => {
        if (
          section.name === currentSection.name &&
          section.uiSectionId !== currentSection.uiSectionId
        ) {
          duplicateName = true;
        }
      });
      return duplicateName;
    },

    handleSectionFocus(ref, section, name) {
      if (this.mode !== "view") {
        section.isEditMode = true;
        // section.name = "";
        section.name = name ? name : "Section title";
        this.formData = JSON.parse(JSON.stringify(this.formData));
        setTimeout(() => {
          this.$refs[ref][0].focus();
          this.$refs[ref][0].select();
        }, 100);
      }
    },

    handleFormNameFocus() {
      this.isFormNameEditing = true;
    },

    handleFormNameBlur() {
      this.isFormNameEditing = false;
    },

    handleDesNameFocus() {},

    handleDesNameBlur() {},

    capitalizeFirstLetter(string) {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    handlePress(e) {
      let keyCode = e.keyCode || e.which;
      if (keyCode < 48 || keyCode > 57 || keyCode == 46) {
        e.preventDefault();
        return false;
      }
    },

    handlePressNumbericAndPeriod(e) {
      if (e.key !== '.' && (e.key < '0' || e.key > '9')) {
        e.preventDefault();
        return false;
      }
    },

    hasDecimal(number) {
      return number % 1 !== 0;
    },

    handleQuestionDesFocus(question) {
      question.editDes = true;
      this.formData = JSON.parse(JSON.stringify(this.formData));
    },

    handleQuestionDesBlur(question) {
      question.editDes = false;
      this.formData = JSON.parse(JSON.stringify(this.formData));
    },

    handleSectionBlur(section, name) {
      section.isEditMode = false;
      section.name = "";
      section.name = name ? name : "Section title";
    },

    handleFormWeightChange() {
      //  TODO
    },

    handleNoManualWeightChecked() {
      let avgWeight = 0;
      if (this.formData.sections.length === 3) {
        this.formData.sections.forEach((section, index) => {
          if (index === this.formData.sections.length - 1) {
            section.weight = 34;
          } else {
            section.weight = 33;
          }
          this.balanceQuestionWeight(section);
        });
      } else {
        avgWeight = 100 / this.formData.sections.length;
        this.formData.sections.forEach((section) => {
          section.weight = avgWeight;
          this.balanceQuestionWeight(section);
        });
      }
    },

    balanceSectionWeight() {
      let avgWeight = 0;
      if (this.formData.sections.length === 3) {
        this.formData.sections.forEach((section, index) => {
          if (index === this.formData.sections.length - 1) {
            section.weight = 34;
          } else {
            section.weight = 33;
          }
        });
      } else {
        avgWeight = 100 / this.formData.sections.length;
        this.formData.sections.forEach((section) => {
          section.weight = avgWeight;
        });
      }
    },

    balanceQuestionWeight(section) {
      let avgWeight = 0;
      if (section.questions.length === 3) {
        section.questions.forEach((question, index) => {
          if (index === section.questions.length - 1) {
            question.weight = 34;
          } else {
            question.weight = 33;
          }
        });
      } else {
        avgWeight = 100 / section.questions.length;
        section.questions.forEach((question) => {
          question.weight = avgWeight;
        });
      }
    },

    sumWeight(list) {
      let weight = 0;
      list.forEach((item) => {
        if (item.weight != "") {
          weight = weight + item.weight;
        }
      });
      return weight;
    },

    reset() {
      this.formData.sections = [];
    },
    handleBtnClose() {
      if (this.appVue) {
        if (
          !this.noFormDataChanged &&
          this.mode !== "view" &&
          !this.showLockedModal
        ) {
          this.isPopupVisible = true;
          this.popupAction = "unSavedForm";
          this.popupBodyText =
            "This action will cause you to lose any unsaved changes. Do you want to continue?";
        } else {
          if (this.formListRef) {
            this.formListRef.selectedActionRow = null;
          }
          this.appVue.handleAppModalClose();
        }
      }
    },

    handleBtnViewOnly() {
      this.mode = "view";
      this.showLockedModal = false;
    },

    async handleLockForm() {
      this.isLockLoading = true;
      await this.lockAutoEvalForm({ formId: this.formId });
      this.isLockLoading = false;
      this.showLockedModal = false;
    },

    async handleUnlockForm() {
      this.isLockLoading = true;
      await this.unlockAutoEvalForm({ formId: this.formId });
      this.isLockLoading = false;
    },

    getSelectedQuestions() {
      this.selectedQuestions = [];
      this.formData.sections.forEach((section) => {
        section.questions.forEach((question) => {
          if (question.libraryQuestionId) {
            this.selectedQuestions.push(question.libraryQuestionId);
          }
        });
      });
    },
    checkPhraseMatchLimit() {
      let phraseMatchCount = 0;
      this.formData.sections.forEach((section) => {
        section.questions.forEach((question) => {
          if(question.questionType === "PHRASE_MATCH") {
            phraseMatchCount++;
          }
        });
      });
      if(phraseMatchCount >= this.phraseMatchLimit) {
        return true;
      }
      else {
        return false;
      }
    },
    refreshQuestionList() {
      this.getSelectedQuestions();
      this.categoryQuestions.forEach((item) => {
        item.dropdownQuestions = [];
        item.questions.forEach((question) => {
          let questionObj = JSON.parse(JSON.stringify(question));
          if(question.questionType === "PHRASE_MATCH") {
            questionObj.disabled = false;
            item.dropdownQuestions.push(questionObj);
          }
          else {
            questionObj.disabled = true;
            if (!this.selectedQuestions.includes(question.libraryQuestionId)) {
              questionObj.disabled = false;
            }
            item.dropdownQuestions.push(questionObj);
          }
        });
      });
      // this.formData = JSON.parse(JSON.stringify(this.formData))
    },
    getQuestionList(categoryId) {
      let list = [];
      this.categoryQuestions.forEach((item) => {
        if (item.libraryCategoryId === categoryId) {
          list = item.dropdownQuestions;
        }
      });
      return list;
    },

    getAllQuestionList(categoryId) {
      let list = [];
      this.categoryQuestions.forEach((item) => {
        if (item.libraryCategoryId === categoryId) {
          list = item.questions;
        }
      });
      return list;
    },

    getAvailableSections(currentIndex) {
      let list = [];
      this.formData.sections.forEach((section, index) => {
        if (currentIndex !== index) {
          list.push(section);
        }
      });
      return list;
    },

    newSection() {
      this.internalSectionIdIncrease++;
      let sectionObj = {
        id: 0,
        uiSectionId: this.internalSectionIdIncrease,
        name: "Section title",
        weight: 1,
        target:'',
        questions: [],
      };
      this.formData.sections.push(sectionObj);
    },

    removeSection(sections, index) {
      sections.splice(index, 1);
      this.refreshQuestionList();
      this.formData = JSON.parse(JSON.stringify(this.formData));
    },

    moveSectionUp(index, list, ref) {
      if (index > 0) {
        this.moveItem(list, index, index - 1);
        if (document.querySelector(".wy-evaluation-form-content")) {
          // ref[0].style.border = '2px solid red';
          ref[0].style.backgroundColor = "#eff4ff";
          if (ref[0].classList.contains("fade-out-border-color")) {
            ref[0].classList.remove("fade-out-border-color");
          }
          setTimeout(() => {
            document.querySelector(".wy-evaluation-form-content").scrollTop -=
              ref[0].offsetHeight + 20;
            ref[0].classList.add("fade-out-border-color");
          }, 20);
        }
      }
    },

    moveSectionDown(index, list, ref) {
      if (index < list.length - 1) {
        this.moveItem(list, index, index + 1);
        if (document.querySelector(".wy-evaluation-form-content")) {
          // ref[0].style.border = '2px solid red';
          ref[0].style.backgroundColor = "#eff4ff";
          if (ref[0].classList.contains("fade-out-border-color")) {
            ref[0].classList.remove("fade-out-border-color");
          }
          setTimeout(() => {
            document.querySelector(".wy-evaluation-form-content").scrollTop +=
              ref[0].offsetHeight + 20;
            ref[0].classList.add("fade-out-border-color");
          }, 20);
        }
        // this.$refs[scrollRef].scrollTop += ref[0].offsetHeight;
      }
    },

    moveItem(array, fromIndex, toIndex) {
      if (
        fromIndex < 0 ||
        fromIndex >= array.length ||
        toIndex < 0 ||
        toIndex >= array.length
      ) {
        return array;
      }
      const element = array.splice(fromIndex, 1)[0];
      array.splice(toIndex, 0, element);

      return array;
    },

    newQuestion(section) {
      this.internalQuestionIdIncrease++;
      let questionObj = {
        uiQuestionId: this.internalQuestionIdIncrease,
        text: null,
        description: "",
        uiCategoryId: null,
        options: [],
        weight: 1,
        displayOnLoad: true
      };
      section.questions.push(questionObj);
    },

    gotoCustomQuestion() {
      this.$root.$emit(`fire-app-modal-events`, "/autoQA/wy-evaluation-new-question.vue", this.module);
    },

    isCustomCategory(categoryId) {
      return categoryId === this.customCategoryId;
    },

    isCustomQuestion(question) {
      return question.categoryText === this.libraryCategoryName; // This is not a good way to recognized custom question, need to change it later.
    },

    getCategoryId(libraryQuestionId) {
      let categoryId = null;
      this.categoryQuestions.forEach((item) => {
        item.questions.forEach((question) => {
          if(question.libraryQuestionId === libraryQuestionId) {
            categoryId = item.libraryCategoryId;
          }
        });
      });
      return categoryId;
    },

    isPhraseMatchQuestion(question) {
      if(question.libraryCategoryId) {
        return this.categoryQuestions.some((item) => {
          return (item.libraryCategoryId === question.libraryCategoryId) && item.questions.some((question) => {
            return question.questionType && question.questionType === "PHRASE_MATCH"
          });
        })
      }
      else {
        return question.questionType && question.questionType === "PHRASE_MATCH"
      }
      
    },

    addPhrase(question) {
      question.phraseMatchExamples.push("");
      this.formData = JSON.parse(JSON.stringify(this.formData));
    },

    showAddExamplesBtn(question) {
      if(question.phraseMatchType === 'EXACT') {
        return question.phraseMatchExamples.length < this.phraseExactMatchExamplesLimit;
      }
      else {
        return question.phraseMatchExamples.length < this.phraseAIMatchExamplesLimit;
      }
    },

    handlePhraseClick(question, index) {
      question.inputExampleVisible = true;
      question.phraseUpdate = true;
      question.selectedTagIndex = index;
      question.inputExampleValue = question.phraseMatchExamples[index];
      question.oldInputExampleValue = question.phraseMatchExamples[index];
      setTimeout(() => {
        if (this.$refs.saveTagInput && this.$refs.saveTagInput.length > 0 && this.$refs.saveTagInput[0].$el) {
          this.handleInputKeyup(this.$refs);
          this.$refs.saveTagInput[0].$el.style.visibility = 'visible';
          this.$refs.saveTagInput[0].$refs.input.focus();
        }
      }, 10)
    },

    handlePhaseClose(question, index) {
      question.phraseMatchExamples.splice(index, 1);
    },

    handleInputKeyup(refs) {
      if (refs.saveTagInput && refs.saveTagInput.length > 0 && refs.saveTagInput[0]) {
        let textbox = refs.saveTagInput[0].$el.querySelector('input');
        if (!textbox.startW) { textbox.startW = textbox.offsetWidth; }
        var style = textbox.style;
        style.width = 0;
        var desiredW = textbox.scrollWidth + 20;
        desiredW += textbox.offsetHeight;
        style.width = Math.max(desiredW, textbox.startW) + 'px';
      }
    },

    handleInputConfirm(question) {
      let inputExampleValue = question.inputExampleValue.trim();
      if(question.phraseUpdate) {
        if (inputExampleValue !== '' && inputExampleValue !== question.oldInputExampleValue) {
          question.phraseMatchExamples[question.selectedTagIndex] = inputExampleValue;
          // question.phraseMatchExamples.push(inputExampleValue);
          // setTimeout(() => {
          //   question.phraseMatchExamples[question.selectedTagIndex] = inputExampleValue;
          //   question.phraseMatchExamples.pop();
          // }, 10)
        }
        else {
          question.phraseMatchExamples[question.selectedTagIndex] = question.oldInputExampleValue;
        }
        question.phraseUpdate = false;
      }
      else {
        if (inputExampleValue && inputExampleValue !== '') {
          question.phraseMatchExamples.push(inputExampleValue);
        }
      }
      question.inputExampleVisible = false;
      question.inputExampleValue = '';
    },

    showInput(question) {
      question.inputExampleVisible = true;
      question.inputExampleValue = '';
      setTimeout(() => {
        this.$refs.saveTagInput[0].$el.style.visibility = 'visible';
        this.$refs.saveTagInput[0].$refs.input.focus();
      }, 10)
    },

    phraseMatchDuplicate(question, tag) {
      let duplicate = false;
      let foundTimes = 0;
      question.phraseMatchExamples.forEach((item) => {
        if(item === tag) {
          foundTimes ++
        }
      });
      if(foundTimes > 1) {
        duplicate = true;
      }
      return duplicate;
    },

    async categoryChanged(libraryCategoryId, question) {
      question.libraryQuestionId = null;
      question.libraryCategoryId = libraryCategoryId;
      question.categoryText = this.getCategoryText(question.uiCategoryId);
      
      question.description = "";
      // if(this.isCustomQuestion(question)) {
      //   question.description = question.defaultDescription;
      // }
      question.options = [];
      if(this.isPhraseMatchQuestion(question)) {
        question.phraseMatchExamples = [];
        question.phraseMatchSentBy = "BOTH";
        question.inputExampleVisible = false;
        question.inputExampleValue = "";
        let currentQuestions = this.getAllQuestionList(question.uiCategoryId);
        currentQuestions.forEach(currentQuestion => {
          if(currentQuestion.phraseMatchType === 'EXACT') {
            question.phraseMatchType = "EXACT";
            question.libraryQuestionId = currentQuestion.libraryQuestionId;
          }
        })
        this.questionChanged(question.libraryQuestionId, question, true);
      }
      else {
        question.text = null;
        if(question.phraseMatchExamples) {
          delete question.phraseMatchExamples
        }
        if(question.phraseMatchType) {
          delete question.phraseMatchType
        }
        if(question.phraseMatchSentBy) {
          delete question.phraseMatchSentBy
        }
      }
      if(question.categoryText === this.libraryCategoryName) {
        question.isCustomCategory = true;
      }
      else {
        question.isCustomCategory = false;
      }
    },

    questionChanged(id, question, isCategoryChanged) {
      this.refreshQuestionList();
      // if(this.isCustomQuestion) {
      //   this.customQuestionList.forEach((item) => {
      //     if(item.questionId === id) {
      //       question.text = item.questionName;
      //       question.options = item.options;

      //       question.questionPromptText = item.promptText;
      //       question.questionPromptDefinition = item.promptDefinition;
      //       question.questionPromptExample = item.promptExample;
      //       question.questionPromptOrder = item.promptOrder;
      //       question.questionPromptTextTemplate = item.questionPromptTextTemplate
      //       question.questionPromptDefinitionTemplate = item.questionPromptDefinitionTemplate;
      //     }
      //   });
      //   console.log("question",question, this.customQuestionList)
      // }
      // else {
        let currentQuestions = this.getAllQuestionList(question.uiCategoryId);
        currentQuestions.forEach((item) => {
          if (item.libraryQuestionId === id) {
            question.libraryQuestionId = item.libraryQuestionId;
            question.questionKey = item.questionKey;
            question.options = item.options;
            question.questionType = item.questionType;
            question.categoryText = this.getCategoryText(question.uiCategoryId);
            question.thresholdOperator = null;
            if (question.questionType === "METADATA") {
              question.thresholdLabel = item.thresholdLabel;
              question.thresholdOperator = item.thresholdOperator;
              question.thresholdValue = "";
            }
            if (this.isPhraseMatchQuestion(question)) {
              if(isCategoryChanged) {
                question.text = ''
              }
              question.phraseMatchType = item.phraseMatchType;
            }
            else {
              question.text = item.libraryQuestionText
                ? item.libraryQuestionText
                : (item.libraryQuestionId !==null && typeof item.libraryQuestionId === 'number') 
                    ? item.libraryQuestionId.toString() : '';
              delete question.inputExampleVisible
              delete question.inputExampleValue
            }
            question.description = (item.libraryQuestionDescription == null) ? "" : item.libraryQuestionDescription;
            question.questionPromptText = item.promptText;
            question.questionPromptDefinition = item.promptDefinition;
            question.questionPromptExample = item.promptExample;
            question.questionPromptOrder = item.promptOrder;
            question.questionPromptTextTemplate = item.questionPromptTextTemplate
            question.questionPromptDefinitionTemplate = item.questionPromptDefinitionTemplate;
          }
        });
      // }
      
      this.formData = JSON.parse(JSON.stringify(this.formData));
    },

    operatorChanged(question) {
      let currentQuestions = this.getAllQuestionList(question.uiCategoryId);
      currentQuestions.forEach((item) => {
        if (item.libraryQuestionId === question.libraryQuestionId) {
          question.options = [];
          item.options.forEach((itemOption) => {
            if (
              itemOption.optionKey === "over" &&
              question.thresholdOperator === "<="
            ) {
              question.options.push(itemOption);
            }
            if (
              itemOption.optionKey === "over_or_equal" &&
              question.thresholdOperator === "<"
            ) {
              question.options.push(itemOption);
            }
            let optionKey = this.thresholdOperatorMapping[
              question.thresholdOperator
            ]
              ? this.thresholdOperatorMapping[question.thresholdOperator]
              : "";
            if (optionKey !== "" && itemOption.optionKey === optionKey) {
              question.options.push(itemOption);
            }
          });
        }
      });
    },

    getCategoryText(categoryId) {
      let categoryName = "";
      this.categoryQuestions.forEach((item) => {
        if (item.libraryCategoryId === categoryId) {
          categoryName = item.categoryName;
        }
      });
      return categoryName;
    },

    validateQuestionsLength(section) {
      return section.questions.length < 5;
    },

    moveQuestion(sectionId, questionIdex, section, question) {
      if (typeof sectionId !== "undefined") {
        let validate = false;
        this.formData.sections.forEach((item) => {
          if (item.uiSectionId === sectionId) {
            validate = this.validateQuestionsLength(item);
          }
        });
        if (validate) {
          this.formData.sections.forEach((item) => {
            if (item.uiSectionId === sectionId) {
              //set question id and option id to null
              section.questions[questionIdex].id = null;
              section.questions[questionIdex].options.forEach((option) => {
                option.id = null;
              });
              item.questions.unshift(section.questions[questionIdex]);
            }
          });
          section.questions.splice(questionIdex, 1);
          setTimeout(() => {
            if (document.querySelector(".wy-evaluation-form-content")) {
              let dom = document.getElementById(question.uiQuestionId);
              dom.style.backgroundColor = "#eff4ff";
              if (dom.classList.contains("fade-out-border-color")) {
                dom.classList.remove("fade-out-border-color");
              }
              document.querySelector(".wy-evaluation-form-content").scrollTop =
                dom.offsetTop - 150;
              dom.classList.add("fade-out-border-color");
            }
          }, 20);
        } else {
          let msg =
            "This section has reached the maximum limit for questions, no additional questions can be added.";
          this.handleAlertMsg(msg);
        }
      }
    },

    removeQuestion(questions, index) {
      questions.splice(index, 1);
      this.refreshQuestionList();
      this.formData = JSON.parse(JSON.stringify(this.formData));
      // this.questionChanged(questions[0].libraryQuestionId, questions[0])
    },

    async handleDeleteForm() {
      this.isPopupVisible = true;
      this.popupAction = "delete";
      this.popupBodyText =
        "Deleting a form is permanent. Deleted forms cannot be used for future evaluations. Are you sure you want to delete this form?";
    },

    async handleArchiveForm() {
      this.isPopupVisible = true;
      this.popupAction = "archive";
      this.popupBodyText =
        "Archiving a form is permanent. Archived forms cannot be used for future evaluations. Are you sure you want to archive this form?";
    },

    async handlePopupConfirm() {
      if (this.popupAction === "delete") {
        await this.formListRef.handleDelete();
        this.isPopupVisible = false;
      }
      if (this.popupAction === "archive") {
        this.isPopupVisible = false;
        this.loading = true;
        await this.formListRef.handleArchive();
        this.formData.status = "archived";
        this.loading = false;
      }
      if (this.popupAction === "unSavedForm") {
        this.isPopupVisible = false;
      }
      if (this.formListRef) {
        this.formListRef.selectedActionRow = null;
      }
      if (this.popupAction !== "archive") {
        this.appVue.handleAppModalClose();
      }
    },

    async handlePublishForm() {
      let formDataBackup = JSON.parse(JSON.stringify(this.formData));
      if (this.publishValidation()) {
        if (!this.formData.manualWeighting) {
          this.handleNoManualWeightChecked();
        }
        let formData = this.prepareWeightFormat();
        formData.status = "published";
        this.loading = true;
        let res = await this.updateAutoEvalForm(formData);
        if (res.data) {
          if (res.status === 200) {
            if (this.preMsgObj == null) {
              this.preMsgObj = this.$message({
                dangerouslyUseHTMLString: false,
                duration: 3000,
                showClose: true,
                customClass: "evaluation-form-save-success-msg",
                message: "Publish Successful",
                onClose: () => {
                  this.preMsgObj = null;
                },
              });
            }
            this.formData = res.data;
            this.formData.status = "published";
            this.prepareFormData();
            if (!this.formListRef.selectedActionRow) {
              this.formListRef.selectedActionRow = this.formData;
            }
            this.formListRef.selectedActionRow.status = "published";
            this.mode = "view";
            this.formListRef.fetchFormManagerList();
          } else if (res.status === 409) {
            let msg = this.$t(`errorCode.code${res.data.errorCode}`);
            this.formData = JSON.parse(JSON.stringify(formDataBackup));
            this.handleAlertMsg(msg);
          }
        }
        this.loading = false;
      }
    },

    prepareWeightFormat() {
      let formData = JSON.parse(JSON.stringify(this.formData));
      if(!this.formData.targetEnabled) {
        this.formData.targetScoringStart = 0;
        this.formData.targetScoringEnd = 1;
      }
      formData.sections.forEach((section) => {
        if(section.target === '') {
          section.target = null;
        }
        section.weight = section.weight / 100;
        section.questions.forEach((question) => {
          if (
            question.questionType &&
            question.questionType === "METADATA" &&
            question.questionKey !== "number_of_hold_events"
          ) {
            question.thresholdValue = question.thresholdValue * 1000;
          }
          question.weight = question.weight / 100;
          if (question.questionType === "PHRASE_MATCH") {
            delete question.inputExampleVisible;
            delete question.inputExampleValue;
            delete question.phraseUpdate;
            delete question.selectedTagIndex;
            delete question.oldInputExampleValue;
          }
          delete question.isCustomCategory;
        });
      });
      return formData;
    },

    async handleSaveForm() {
      if (!this.formData.manualWeighting) {
        this.handleNoManualWeightChecked();
      }
      let formData = this.prepareWeightFormat();
      this.loading = true;
      let res = await this.updateAutoEvalForm(formData);
      // let res = {}
      if (res.data) {
        if (res.status === 200) {
          if (this.preMsgObj == null) {
            this.preMsgObj = this.$message({
              dangerouslyUseHTMLString: false,
              duration: 3000,
              showClose: true,
              customClass: "evaluation-form-save-success-msg",
              message: "Save Successful",
              onClose: () => {
                this.preMsgObj = null;
              },
            });
          }
          this.mode = "edit";
          this.formData = res.data;
          this.prepareFormData();
          if (!this.formListRef.selectedActionRow) {
            this.formListRef.selectedActionRow = this.formData;
          }
          this.formListRef.fetchFormManagerList();

          const isNewForm = this.formId == null || this.formId === 0;
          if (isNewForm) {
            this.formId = res.data.formId;
          }
        } else if (res.status === 409) {
          let msg = this.$t(`errorCode.code${res.data.errorCode}`);
          this.handleAlertMsg(msg);
        }
      } else {
        if (this.preMsgObj == null) {
          this.preMsgObj = this.$message({
            dangerouslyUseHTMLString: false,
            duration: 5000,
            showClose: true,
            customClass: "evaluation-form-internal-error-warning-msg",
            message: "Internal Error",
            onClose: () => {
              this.preMsgObj = null;
            },
          });
        }
      }
      this.loading = false;
    },

    prepareFormData() {
      if (this.formData.sections.length > this.maxSections) {
        this.formData.sections.splice(
          this.maxSections,
          this.formData.sections.length - 1
        );
      }
      if(!this.formData.showTargetRange) {
        this.formData.showTargetRange = false;
      }
      else {
        this.formData.showTargetRange = true;
      }
      if(!this.formData.targetScoringRanges || this.formData.targetScoringRanges.length === 0) {
        this.formData.targetScoringRanges = ['Needs improvement', 'Meets expectations', 'Exceeds expectations'];
      }
      this.targetScoringRange1 = this.formData.targetScoringRanges[0];
      this.targetScoringRange2 = this.formData.targetScoringRanges[1];
      this.targetScoringRange3 = this.formData.targetScoringRanges[2];

      if(!this.formData.targetEnabled) {
        this.formData.targetEnabled = false;
        this.targetRange = [0, 1];
        this.formData.targetScoringStart = this.targetRange[0];
        this.formData.targetScoringEnd = this.targetRange[1];
      }

      if(this.formData.targetScoringStart || this.formData.targetScoringEnd) {
        this.targetRange = [this.formData.targetScoringStart, this.formData.targetScoringEnd];
      }
      else {
        this.formData.targetScoringStart = this.targetRange[0];
        this.formData.targetScoringEnd = this.targetRange[1];
      }
      this.formData.sections.forEach((section) => {
        section.isEditMode = false;
        // section.target = null
        section.weight =
        section.weight <= 1 ? parseInt(section.weight * 10000) / 100 : section.weight;
        if(!section.target && section.target !== 0) {
          section.target = '';
        }
        if (!section.uiSectionId) {
          this.internalSectionIdIncrease++;
          section.uiSectionId = this.internalSectionIdIncrease;
        }
        if (section.questions.length > this.maxQuestions) {
          section.questions.splice(
            this.maxQuestions,
            section.questions.length - 1
          );
        }
        section.questions.forEach((question) => {
          if (question.description == null) {
            question.description = "";
          }
          question.editDes = false;
          question.weight =
            question.weight <= 1
            ? parseInt(question.weight * 10000) / 100
              : question.weight;
          if (question.questionType && question.questionType === "METADATA" && question.questionKey !== "number_of_hold_events") {
            question.thresholdValue =
              question.thresholdValue < 1000
                ? 0
                : question.thresholdValue / 1000;
          }
          if(question.questionType === "PHRASE_MATCH") {
            question.inputExampleVisible = false;
            question.inputExampleValue = '';
          }
          if (!question.uiQuestionId) {
            this.internalQuestionIdIncrease++;
            question.uiQuestionId = this.internalQuestionIdIncrease;
          }
          if (!question.uiCategoryId) {
            this.categoryQuestions.forEach((category) => {
              category.questions.forEach((item) => {
                if (item.libraryQuestionId === question.libraryQuestionId) {
                  question.uiCategoryId = category.libraryCategoryId;
                  question.categoryText = this.getCategoryText(question.uiCategoryId);
                }
              });
            });
          }
        });
      });
      this.cloneFormData = JSON.parse(JSON.stringify(this.formData));
    },

    checkAndHandleBackCompatible() {
      this.formData.sections.forEach((section) => {
        section.questions.forEach((question) => {
          // handle Back Compatible for Customer Effort operator
          let needBackCompatible = false;
          if (question.questionType && question.questionType === "METADATA") {
            question.options.forEach((itemOption) => {
              if (itemOption.optionKey === "over_or_equal") {
                needBackCompatible = true;
              }
            });
            if (needBackCompatible) {
              this.operatorChanged(question);
            }
          }
        });
      });
    },

    handleAlertMsg(msg) {
      if (this.preMsgObj == null) {
        this.preMsgObj = this.$message({
          dangerouslyUseHTMLString: false,
          duration: 5000,
          showClose: true,
          customClass: "evaluation-form-publish-warning-msg",
          message: msg,
          onClose: () => {
            this.preMsgObj = null;
          },
        });
      }
    },

    publishValidation() {
      let valid = true;
      this.formData.sections.forEach((section) => {
        if (section.questions.length === 0) {
          let msg =
            "Unable to Publish: Each section must have at least one question";
          this.handleAlertMsg(msg);
          valid = false;
          return false;
        }
      });
      if (this.formData.manualWeighting && valid) {
        if (this.sumWeight(this.formData.sections) !== 100) {
          let msg =
            "Unable to Publish: The weight for all sections must equal 100 percent";
          this.handleAlertMsg(msg);
          return false;
        }
        this.formData.sections.forEach((section) => {
          if (this.sumWeight(section.questions) !== 100) {
            let msg =
              "Unable to Publish: The weight for all questions in each section must equal 100 percent";
            this.handleAlertMsg(msg);
            return false;
          }
        });
      }
      return valid;
    },

    generateInternalSectionIdIncrease() {
      this.formData.sections.forEach((section) => {
        if (section.id && this.internalSectionIdIncrease < section.id) {
          this.internalSectionIdIncrease = section.id;
        }
        if (
          section.uiSectionId &&
          this.internalSectionIdIncrease < section.uiSectionId
        ) {
          this.internalSectionIdIncrease = section.uiSectionId;
        }
      });
    },

    generateInternalQuestionIdIncrease() {
      this.formData.sections.forEach((section) => {
        section.questions.forEach((question) => {
          if (question.id && this.internalQuestionIdIncrease < question.id) {
            this.internalQuestionIdIncrease = question.id;
          }
          if (
            question.uiQuestionId &&
            this.internalQuestionIdIncrease < question.uiQuestionId
          ) {
            this.internalQuestionIdIncrease = question.uiQuestionId;
          }
        });
      });
    },

    closeAllPopupMenus() {
      if (
        this.$refs.sectionPopupMenu &&
        this.$refs.sectionPopupMenu.length > 1
      ) {
        this.$refs.sectionPopupMenu.forEach((item) => {
          item.hide();
        });
      }
      if (
        this.$refs.questionPopupMenu &&
        this.$refs.questionPopupMenu.length > 1
      ) {
        this.$refs.questionPopupMenu.forEach((item) => {
          item.hide();
        });
      }
    },
    async getAutoQAEvalQuestionList() {
      let res = await this.fetchAutoQAEvalQuestionList();
      if (res && res.data) {
        this.categoryQuestions = res.data;
        this.categoryQuestions.forEach((category) => {
          category.questions.forEach((question) => {
            question.options.forEach((option) => {
              option.label = option.libraryOptionText;
              option.points = option.libraryOptionPoint
                ? option.libraryOptionPoint
                : 0;
              option.displayOrder = option.libraryOptionDisplayOrder
                ? option.libraryOptionDisplayOrder
                : 0;
                option.libraryOptionPoints = option.libraryOptionPoint
              delete option.libraryOptionText;
              delete option.libraryOptionPoint;
              delete option.libraryOptionDisplayOrder;
            });
          });
        });
        this.refreshQuestionList();
      }
    }
  },

  mounted() {
    window.addEventListener("resize", () => {
      this.closeAllPopupMenus();
    });
    if (this.$refs.sections) {
      this.$refs.sections.addEventListener("scroll", () => {
        this.closeAllPopupMenus();
      });
    }
  },

  async created() {
    // this.getMockData()
    // this.loading = true;
    let res = await this.fetchAutoQAEvalQuestionList();
    if (res && res.data) {
      this.categoryQuestions = res.data;
      this.categoryQuestions.forEach((category) => {
        category.questions.forEach((question) => {
          question.options.forEach((option) => {
            option.label = option.libraryOptionText;
            option.points = option.libraryOptionPoint
              ? option.libraryOptionPoint
              : 0;
            option.displayOrder = option.libraryOptionDisplayOrder
              ? option.libraryOptionDisplayOrder
              : 0;
              option.libraryOptionPoints = option.libraryOptionPoint
            delete option.libraryOptionText;
            delete option.libraryOptionPoint;
            delete option.libraryOptionDisplayOrder;
          });
        });
      });
    }
    this.formData = {
      formId: 0,
      name: "",
      description: "",
      manualWeighting: false,
      status: "editable",
      targetScoringRanges: ['Needs improvement', 'Meets expectations', 'Exceeds expectations'],
      sections: [],
    };
    if(this.isRoleAllow([90002, 90003])) {
      this.formData.additionalInstructions = "";
    }
    this.formListRef = this.appVue.appModalComponent.options;
    if (
      this.formListRef &&
      this.formListRef.selectedActionRow &&
      this.formListRef.selectedActionRow.mode
    ) {
      this.mode = this.formListRef.selectedActionRow.mode;
    } else {
      this.mode = "new";
    }
    if (
      this.formListRef &&
      this.formListRef.selectedActionRow &&
      this.formListRef.selectedActionRow.inTask
    ) {
      this.inTask = this.formListRef.selectedActionRow.inTask;
    }
    if (
      this.formListRef &&
      this.formListRef.selectedActionRow &&
      this.formListRef.selectedActionRow.formId
    ) {
      this.formId = this.formListRef.selectedActionRow.formId;
      let res = await this.fetchAutoQAEvalFormById(this.formId);
      if (res && res.data) {
        this.formData = res.data;
        this.generateInternalSectionIdIncrease();
        this.generateInternalQuestionIdIncrease();
        this.prepareFormData();
        this.mode = this.formData.status == "editable" ? "edit" : "view";
      }
    } else {
      this.prepareFormData();
    }
    // this.checkAndHandleBackCompatible()
    this.refreshQuestionList();

    const isLocked = this.formData.lockedBy != null;
    const isFormOwnerCurrentUser =
      this.formData.lockedBy ==
      (this.authUser && this.authUser.user && this.authUser.user.email);

    this.loading = false;

    const isNewForm = this.formId == null || this.formId === 0;
    if (isNewForm) return;

    if (isLocked && !isFormOwnerCurrentUser) {
      this.showLockedModal = true;
    }
  },

  beforeDestroy() {
    const lockedModalIsVisible = this.showLockedModal;
    const isFormOwnerCurrentUser =
      this.formData.lockedBy ==
      (this.authUser && this.authUser.user && this.authUser.user.email);

    const closeFormWhenFormAlreadyLockedBySomeoneElse =
      lockedModalIsVisible && !isFormOwnerCurrentUser;
    const closeFormInViewMode = this.mode == "view";

    if (closeFormWhenFormAlreadyLockedBySomeoneElse || closeFormInViewMode)
      return;

    if (this.mode == "edit") {
      this.handleUnlockForm();
    }
  },
};
</script>

<style lang="scss">
.wy-brand.wy-product-aq.wy-evaluationNewForm-page {
  overflow-x: auto;
  overflow-y: hidden;
}
.wy-evaluation-new-form {
  display: flex;
  max-width: 1800px;
  min-width: 1200px;
  text-align: center;
  margin: auto;
  // height: 100%;
  height: calc(100% + 80px);
  .locked-modal-wrapper {
    position: fixed;
    height: 100%;
    width: 100%;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 99999;

    display: flex;
    justify-content: center;
    align-items: center;

    .modal-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 600px;
      height: 200px;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
      padding: 20px 30px;
      text-align: left;
      color: #595959;
      h3 {
        color: black;
        font-weight: 500;
      }
      .text {
        font-size: 15px;
      }
      .confirm {
        margin-top: 20px;
      }
      .btn-wrapper {
        display: flex;
        justify-content: flex-end;
        .el-button {
          background-color: #fff;
          border-radius: 3px;
          border-color: #153a59;
          width: max-content;
          padding: 10px 14px;
          color: #153a59;
        }
        .cancel.el-button {
          background-color: #153a59;
          color: #fff;
        }
      }
    }
  }
  .wy-evaluation-form-content {
    min-width: 800px;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    scroll-behavior: smooth;
    //// width: calc(100% - 400px);
  }
  .wy-evaluation-preview {
    // width: 400px;
    float: right;
  }
  .el-form {
    display: flex;
    max-width: 1800px;
    min-width: 1200px;
    text-align: center;
    // margin: auto;
  }
  .el-container {
    display: flex;
    max-width: 1800px;
    min-width: 1200px;
    text-align: center;
    flex: unset;
  }
  .new-form-body.read-only {
    pointer-events: none;
    opacity: 0.7;
  }

  .new-form-header {
    // padding: 30px 40px;
    padding: 30px 0px 30px 40px;
    margin-right: 20px;
    border-bottom: 1px solid #000;
    text-align: left;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 999;
    .button-section {
      margin-left: auto;
      display: flex;
      float: right;
      position: relative;
      top: 5px;
      height: 30px;
      button {
        margin-right: 10px;
        border: 0px;
        box-shadow: none;
        border-radius: 2px;
        font-weight: 400;
        color: #000;
        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-radius: 5px;
      }
      button:disabled {
        color: rgba(0, 0, 0, 0.26) !important;
        background-color: rgba(0, 0, 0, 0.12) !important;
        cursor: not-allowed;
      }
      .btn-delete {
        cursor: pointer;
        width: 92px;
      }
      .btn-publish {
        cursor: pointer;
        width: 92px;
      }
      .btn-save-draft {
        cursor: pointer;
        width: 112px;
        color: #fff;
        font-weight: 600;
        background-color: #003b5c;
      }
      .btn-save-draft:hover {
        background-color: #000;
      }
      .btn-close {
        cursor: pointer;
        font-size: 21px;
        font-weight: 700;
        float: right;
        margin-top: 5px;
      }
    }
    .text-input.form-name {
      max-width: 508px;
      font-size: 16px;
      width: calc(100% - 475px);
      input.el-input__inner {
        font-size: 16px;
        border-width: 1px !important;
        border-radius: 5px;
        padding-left: 15px;
        border-color: #d2d8dc;
      }
      .el-input.is-active .el-input__inner,
      .el-input__inner:focus {
        // border-color: #D2D8DC !important;
        border-color: #1a1c1e !important;
      }
    }
    .el-input.is-disabled .el-input__inner {
      background-color: #fff;
      color: #606266;
      opacity: 0.7;
      cursor: default;
    }
    .status-editable,
    .status-published {
      width: 90px;
      height: 20px;
      border-radius: 90px;
      padding: 5px 0px 0px 10px;
      margin-left: 15px;
      font-size: 11.2px;
      background-color: #efeef7;
      color: #3b3267;
      display: inline-flex;
      position: relative;
      top: -3px;
    }
    .status-published {
      width: 100px !important;
    }
    .form-name-label.disabled {
      opacity: 0.7;
    }
    .form-name-label {
      font-size: 11px;
      color: #444d54;
      position: absolute;
      top: 24px;
      left: 52px;
      background-color: #fff;
      padding: 0px 5px;
    }
    .warning-msg {
      font-size: 11px;
      color: #ebafba;
      position: absolute;
      top: 71px;
      left: 42px;
    }
    .reminding-msg {
      font-size: 11px;
      color: #444d54;
      position: absolute;
      top: 71px;
      left: 42px;
    }
  }
  .new-form-body.el-loading-parent--relative {
    height: calc(100% - 150px);
  }
  .new-form-body {
    padding: 20px 10px 30px 40px;
    // overflow-y: auto;
    // height: calc(100% - 115px);
    // scroll-behavior: smooth;
    // text-align: left;
    position: relative;
    scroll-behavior: smooth;
    text-align: left;

    .form-history-records {
      .author-info-title {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-top: 30px;
        margin-bottom: 15px;
      }
      .author-info-des {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #444d54;
      }
      .createdBy-updatedBy {
        color: #444d54;
        .createdBy {
          display: inline-block;
          margin: 10px 50px 20px 0px;
          .createdBy-label {
            font-size: 20px;
            font-weight: 400;
            line-height: 28px;
            margin-bottom: 5px;
          }
          .createdBy-des {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
          }
        }
        .updatedBy {
          display: inline-block;
          margin: 10px 50px 20px 0px;
          .updatedBy-label {
            font-size: 20px;
            font-weight: 400;
            line-height: 28px;
            margin-bottom: 5px;
          }
          .updatedBy-des {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
          }
        }
      }
    }
    .div-form-description-title {
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      background: var(--question-editor-stars-icon-white);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: left;
      padding-left: 35px;
    }
    .form_info {
      background: var(--question-editor-question-mark-blue);
      background-repeat: no-repeat;
      background-size: 15px;
      width: 15px;
      height: 15px;
      background-position-y: 0px;
      margin-left: 5px;
      cursor: pointer;
      position: absolute;
      top: 28px;
      left: 300px;
      pointer-events: all !important;
    }
    .div-ai-evaluation-instructions-title {
      position: relative;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      background: var(--question-editor-stars-icon-white);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: left;
      padding-left: 35px;
      .ai-evaluation-instructions_info {
        background: var(--question-editor-question-mark-blue);
        background-repeat: no-repeat;
        background-size: 15px;
        width: 15px;
        height: 15px;
        background-position-y: 0px;
        margin-left: 5px;
        cursor: pointer;
        position: absolute;
        top: 7px;
        left: 438px;
        pointer-events: all !important;
      }
    }
    .div-form-ai-evaluation-instructions {
      position: relative;
      .text-input.ai-evaluation-instructions {
        padding-top: 15px;
        width: 945px;
        font-size: 16px;
        .el-textarea__inner {
          min-height: 120px !important;
          font-size: 16px;
          border-width: 1px !important;
          border-radius: 5px;
          padding-top: 15px;
          padding-left: 15px;
          border-color: #d2d8dc;
          color: #606266;
          font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
          pointer-events: all !important;
          &::-webkit-scrollbar {
            width: 20px;
            cursor: default !important;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 160px;
            border: 2px solid transparent;
            border-top: 4px solid transparent;
            background-clip: content-box;
            background-color: #CAD2DA;
            cursor: default !important;
          }
          &::-webkit-scrollbar-track {
            background:#F3F6F8;
            border-top: 1px solid #CAD2DA;
            border-radius: 5px;
            cursor: default !important;
          }
          &::-webkit-scrollbar:vertical {
            width: 14px;
          }
          &::-webkit-scrollbar-thumb:vertical {
            border-radius: 160px;
            border: 2px solid transparent;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            background-clip: content-box;
            background-color: #CAD2DA;
          }
          &::-webkit-scrollbar-track:vertical {
            // border-left: 1px solid #CAD2DA;
            border-top: none !important;
          }
        }
        .el-textarea__inner::placeholder {
          font-size: 12px !important;
          font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        }
        .el-textarea__inner:focus {
          // border-color: #D2D8DC !important;
          border-color: #1a1c1e !important;
        } 
      }
    }
    

    .ai-evaluation-instructions-label {
      font-size: 11px;
      color: #444d54;
      position: absolute;
      top: 9px;
      left: 11px;
      background-color: #fff;
      padding: 0px 5px;
    }
    
    .text-input.form-description {
      padding-top: 15px;
      width: 945px;
      font-size: 16px;
      .el-textarea__inner {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        min-height: 120px !important;
        font-size: 16px;
        border-width: 1px !important;
        border-radius: 5px;
        padding-top: 15px;
        padding-left: 15px;
        border-color: #d2d8dc;
        color: #606266;
        pointer-events: all !important;
        &::-webkit-scrollbar {
          width: 20px;
          cursor: default !important;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 160px;
          border: 2px solid transparent;
          border-top: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
          cursor: default !important;
        }
        &::-webkit-scrollbar-track {
          background:#F3F6F8;
          border-top: 1px solid #CAD2DA;
          border-radius: 5px;
          cursor: default !important;
        }
        &::-webkit-scrollbar:vertical {
          width: 14px;
        }
        &::-webkit-scrollbar-thumb:vertical {
          border-radius: 160px;
          border: 2px solid transparent;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          background-clip: content-box;
          background-color: #CAD2DA;
        }
        &::-webkit-scrollbar-track:vertical {
          // border-left: 1px solid #CAD2DA;
          border-top: none !important;
        }
      }
      .el-textarea__inner::placeholder {
        font-size: 12px !important;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
      .el-textarea__inner:focus {
        // border-color: #D2D8DC !important;
        border-color: #1a1c1e !important;
      } 
    }
    .form-description-label {
      font-size: 11px;
      color: #444d54;
      position: absolute;
      top: 58px;
      left: 52px;
      background-color: #fff;
      padding: 0px 5px;
    }
    .section-question {
      padding-top: 20px;
      .div-form-target.disabled {
        opacity: 0.5;
        pointer-events: none;
        background-color: #fafaff;
      }
      .title {
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        padding-top: 35px;
        padding-bottom: 15px;
      }
      .description {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }
      .sub_description {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        padding-bottom: 15px;
        padding-top: 15px;
      }
      .sub_description.black-info {
        background: var(--form-editor-info-icon-black);
        background-repeat: no-repeat;
        background-size: 20px;
        padding-top: 0px;
        padding-left: 25px;
        margin-top: 15px;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        border-radius: 2px;
        background-color: #1890ff;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        font-weight: 400;
        color: #1b1f22;
      }
      .sections {
        .section-body.fade-out-border-color {
          //border: 2px solid transparent !important; /* <- here */
          //transition: border 2.5s !important;
          background-color: transparent !important;
          transition: background-color 2.5s !important;
          text-decoration: none;
        }
        .section-body {
          padding-top: 20px;
          margin-bottom: 20px;
          // background-color: #fbfbfb;
          .section-header {
            display: inline-flex;
            position: relative;
            // background-color: #fbfbfb;
            .section-name {
              // margin-left: 5px;
              .span-input-label {
                width: fit-content;
                font-size: 20px;
                position: relative;
                top: 8px;
                padding: 8px 10px;
              }
              .span-input-label.duplicate-section-name {
                background-color: #fff4f4;
              }
              .text-input.duplicate-section-name {
                border: 1px solid #ebafba !important;
                .el-input__inner {
                  background-color: #fff4f4;
                  // border: 1px solid #ebafba;
                }
              }
              .text-input {
                height: 34px !important;
                top: 3px;
                border: 1px solid #000 !important;
                border-radius: 5px;
                input.el-input__inner {
                  // border: 1px solid transparent;
                  height: 34px;
                  border: 0px solid #000 !important;
                  border-width: 0px 0px 0px 0px !important;
                  border-radius: 5px;
                }
              }
              .el-icon-edit {
                background-image: var(--header-icon-edit-pencil);
                background-repeat: no-repeat;
                background-size: 20px;
                width: 20px;
                height: 20px;
                background-position-y: 2px;
                margin-left: 20px;
                cursor: pointer;
              }
              .el-icon-edit:before {
                content: "";
              }
            }
            .warning-msg {
              font-size: 11px;
              color: #ebafba;
              position: absolute;
              top: 40px;
              left: 100px;
            }
            .reminding-msg {
              font-size: 11px;
              color: #444d54;
              position: absolute;
              top: 40px;
              left: 100px;
            }
            .section-weight-div, .section-target-div {
              position: relative;
              .input-section-weight, .input-section-target {
                height: 34px;
                line-height: 40px;
                outline: 0;
                padding: 0 15px;
                width: 145px;
                font-size: 16px;
                line-height: normal;
                transition: border-color 0.2s
                  cubic-bezier(0.645, 0.045, 0.355, 1);
                border: 1px solid #dcdfe6;
                border-width: 1px !important;
                border-radius: 5px;
                padding-left: 10px;
                margin-left: 50px;
                border-color: #d2d8dc;
                position: relative;
                top: 2px;
              }
              .input-section-target {
                margin-left: 10px;
              }
              .section-weight-label, .section-target-label {
                font-size: 11px;
                color: #444d54;
                position: absolute;
                top: -5px;
                left: 61px;
                background-color: transparent;
                padding: 0px 5px;
                z-index: 99;
              }
              .section-target-label {
                left: 18px;
              }
              .section-weight-label-background, .section-target-label-background {
                width: 105px;
                height: 10px;
                position: absolute;
                top: 2px;
                left: 61px;
                background-color: #fff;
              }
              .section-target-label-background {
                left: 18px;
              }
              .section-weight-label-background.disabled, .section-target-label-background.disabled {
                background-color: #fafaff;
              }
              .section-weight-label-background.no-value, .section-target-label-background.no-value {
                background-color: #fff4f4 !important;
              }
            }
            .el-dropdown {
              position: relative;
              font-size: 24px;
              top: 6px;

              .el-dropdown-link {
                .el-icon-three-dots {
                  background-image: var(--header-icon-menu-three-dots);
                  background-repeat: no-repeat;
                  background-size: 26px;
                  width: 20px;
                  height: 24px;
                  background-position-y: 0px;
                  margin-left: 5px;
                  cursor: pointer;
                }
                .el-icon-edit:before {
                  content: "";
                }
                .el-icon-edit {
                  background-image: var(--header-icon-edit-pencil);
                  background-repeat: no-repeat;
                  background-size: 20px;
                  width: 20px;
                  height: 20px;
                  background-position-y: 2px;
                  margin-left: 20px;
                  cursor: pointer;
                }
                .el-icon-edit:before {
                  content: "";
                }
              }
            }
          }
          .section-content {
            padding-left: 50px;
            padding-bottom: 20px;
            // background-color: #fbfbfb;
            .add-question-title {
              padding: 30px 0px 0px 0px;
            }
            .div-add-question-btn {
              padding: 20px 0px 10px 0px;
              .btn-add-question {
                cursor: pointer;
                margin-right: 10px;
                border: 0px;
                color: #fff;
                box-shadow: none;
                background-color: #1890ff;
                border-radius: 5px;
                font-weight: 600;
                width: 150px;
                height: 32px;
              }
            }
            .div-balance-question-weight-btn {
              .btn-balance-question-weight {
                cursor: pointer;
                margin-right: 10px;
                border: 0px;
                color: #1b1f22;
                -webkit-box-shadow: none;
                box-shadow: none;
                background-color: #bfbfbf;
                border-radius: 5px;
                font-weight: 400;
                width: 215px;
                height: 32px;
                margin-right: 300px;
              }

              .question-weight-percentage {
                font-size: 24px;
                font-weight: 700;
                position: relative;
                top: 5px;

                .el-icon-weight-info {
                  position: relative;
                  background-image: var(--header-icon-elv-form-weight-pass);
                  background-repeat: no-repeat;
                  background-size: 24px;
                  width: 24px;
                  height: 24px;
                  top: 3px;
                  left: 10px;
                }
              }
              .question-weight-percentage.red {
                color: #a6182d;
                .el-icon-weight-info {
                  background-image: var(--header-icon-elv-form-weight-warning);
                }
              }
            }

            .questions {
              .question-body.fade-out-border-color {
                //border: 2px solid transparent !important; /* <- here */
                //transition: border 2.5s !important;
                background-color: transparent !important;
                transition: background-color 2.5s !important;
                text-decoration: none;
              }
              .question-body {
                padding-top: 30px;
                margin-top: 10px;
                .gotoCustomQuestion {
                  font-size: 14px;
                  float: right;
                  color: var(--site-font-primary-color);
                  position: relative;
                  top: -16px;
                  left: -100px;
                  .go-to-custom-question-link {
                    cursor: pointer;
                    color: #1890FF;
                    text-decoration: underline;
                  }
                }
                .question-header {
                  display: inline-flex;
                  width: 100%;
                  position: relative;
                  .category-question-section {
                    width: calc(100% - 185px);
                    min-width: 637px;
                    position: relative;
                  }
                  .phrase-match-question-text {
                    display: inline-block;
                    margin-left: auto;
                    position: relative;
                    .phrase-input {
                      font-size: 16px;
                      width: 530px;
                      input.el-input__inner {
                        font-size: 16px;
                        border-width: 1px !important;
                        border-radius: 5px;
                        padding-left: 10px;
                        border-color: #dcd4d2;
                      }
                      .el-input__inner:focus {
                        border-color: #1a1c1e !important;
                      }
                    }
                    .phrase-input.no-value {
                      .el-input__inner {
                        background-color: #fff4f4;
                        border: 1px solid #ebafba;
                      }
                      .el-input__inner:focus {
                        border-color: #f03106 !important;
                      }
                    }
                    .warning-msg {
                      font-size: 11px;
                      color: #ebafba;
                      position: absolute;
                      top: 41px;
                      left: 2px;
                    }
                    .reminding-msg {
                      font-size: 11px;
                      color: #444d54;
                      position: absolute;
                      top: 41px;
                      left: 2px;
                    }
                  }
                  .category-dropdown,
                  .question-dropdown {
                    margin-right: 10px;
                    .el-input--mini .el-input__inner {
                      font-size: 14px;
                      border-width: 1px !important;
                      border-radius: 5px;
                      padding-left: 10px;
                      height: 40px;
                      border-color: #d2d8dc !important;
                    }
                    .el-select__caret {
                      color: #1b1f22;
                    }
                    .el-input.el-input--mini.is-disabled {
                      input.el-input__inner {
                        background-color: #f5f7fa;
                        border-color: #d2d8dc !important;
                      }
                    }
                  }

                  .category-dropdown.no-value,
                  .question-dropdown.no-value {
                    .el-input__inner {
                      background-color: #fff4f4;
                      border: 1px solid #ebafba;
                    }
                  }

                  .category-dropdown {
                    width: 150px;
                  }

                  .question-dropdown {
                    margin-right: 0px !important;
                    width: calc(100% - 370px);
                    min-width: 115px;
                  }

                  .input-question-weight {
                    height: 37px;
                    outline: 0;
                    padding: 0 15px;
                    width: 145px;
                    font-size: 16px;
                    line-height: normal;
                    transition: border-color 0.2s
                      cubic-bezier(0.645, 0.045, 0.355, 1);
                    border: 1px solid #dcdfe6;
                    border-width: 1px !important;
                    border-radius: 5px;
                    padding-left: 10px;
                    border-color: #d2d8dc;
                    margin-left: 10px;
                  }
                  .question-weight-label {
                    font-size: 11px;
                    color: #444d54;
                    position: absolute;
                    top: -6px;
                    right: 78px;
                    background-color: transparent;
                    padding: 0px 5px;
                    z-index: 99;
                  }
                  .question-weight-label-background {
                    width: 112px;
                    height: 10px;
                    position: absolute;
                    top: 0px;
                    right: 78px;
                    background-color: #fff;
                  }
                  .question-weight-label-background.disabled {
                    background-color: #fafaff;
                  }
                  .question-weight-label-background.no-value {
                    background-color: #fff4f4 !important;
                  }
                  .el-dropdown {
                    position: relative;
                    font-size: 24px;
                    top: 5px;
                    .el-dropdown-link {
                      .el-icon-three-dots {
                        background-image: var(--header-icon-menu-three-dots);
                        background-repeat: no-repeat;
                        background-size: 26px;
                        width: 20px;
                        height: 24px;
                        background-position-y: 0px;
                        margin-left: 5px;
                        cursor: pointer;
                      }
                      .el-icon-edit:before {
                        content: "";
                      }
                      .el-icon-edit {
                        background-image: var(--header-icon-edit-pencil);
                        background-repeat: no-repeat;
                        background-size: 20px;
                        width: 20px;
                        height: 20px;
                        background-position-y: 2px;
                        margin-left: 20px;
                        cursor: pointer;
                      }
                      .el-icon-edit:before {
                        content: "";
                      }
                    }
                  }

                  .btn-question-menu {
                    .el-icon-three-dots {
                      background-image: var(--header-icon-menu-three-dots);
                      background-repeat: no-repeat;
                      background-size: 20px;
                      width: 20px;
                      height: 20px;
                      background-position-y: 2px;
                      margin-left: 20px;
                      cursor: pointer;
                    }
                    .el-icon-edit:before {
                      content: "";
                    }
                    .el-icon-edit {
                      background-image: var(--header-icon-edit-pencil);
                      background-repeat: no-repeat;
                      background-size: 20px;
                      width: 20px;
                      height: 20px;
                      background-position-y: 2px;
                      margin-left: 20px;
                      cursor: pointer;
                    }
                    .el-icon-edit:before {
                      content: "";
                    }
                  }
                }
                .category-title {
                  font-size: 11px;
                  position: absolute;
                  left: 102px;
                  top: -15px;
                }
                .question-title {
                  font-size: 11px;
                  position: absolute;
                  left: 262px;
                  top: -15px;
                }
                .question-content.read-only {
                  padding-left: 0px;
                  pointer-events: none;
                  opacity: 0.7;
                  .custom-question-description-label {
                    left: 20px !important;
                  }
                  .custom-question-description-label-background {
                    left: 20px !important;
                  }
                }
                .question-content {
                  padding: 5px;
                  padding-left: 100px;
                  position: relative;

                  .text-input.question-description {
                    padding-top: 15px;
                    width: calc(100% - 10px);
                    font-size: 16px;
                    max-width: 690px;
                    // input.el-input__inner {
                    //   font-size: 16px;
                    //   border-width: 1px !important;
                    //   border-radius: 5px;
                    //   padding-left: 10px;
                    //   border-color: #d2d8dc;
                    // }
                    // .el-input__inner:focus {
                    //   border-color: #1a1c1e !important;
                    // }
                    .el-textarea__inner {
                      min-height: 90px !important;
                      font-size: 16px;
                      border-width: 1px !important;
                      border-radius: 5px;
                      padding-top: 15px;
                      padding-left: 15px;
                      border-color: #d2d8dc;
                      color: #606266;
                      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                      pointer-events: all !important;
                      &::-webkit-scrollbar {
                        width: 20px;
                        cursor: default !important;
                      }
                      &::-webkit-scrollbar-thumb {
                        border-radius: 160px;
                        border: 2px solid transparent;
                        border-top: 4px solid transparent;
                        background-clip: content-box;
                        background-color: #CAD2DA;
                        cursor: default !important;
                      }
                      &::-webkit-scrollbar-track {
                        background:#F3F6F8;
                        border-top: 1px solid #CAD2DA;
                        border-radius: 5px;
                        cursor: default !important;
                      }
                      &::-webkit-scrollbar:vertical {
                        width: 14px;
                      }
                      &::-webkit-scrollbar-thumb:vertical {
                        border-radius: 160px;
                        border: 2px solid transparent;
                        border-left: 4px solid transparent;
                        border-right: 4px solid transparent;
                        background-clip: content-box;
                        background-color: #CAD2DA;
                      }
                      &::-webkit-scrollbar-track:vertical {
                        border-top: none !important;
                      }
                    }
                    .el-textarea__inner:focus {
                      border-color: #1a1c1e !important;
                    }
                  }
                  .text-input.question-description.no-value {
                    .el-input__inner {
                      background-color: #fff4f4;
                      border: 1px solid #ebafba;
                    }
                    .el-input__inner:focus {
                      border-color: #f03106 !important;
                    }
                  }
                  .question-description-label {
                    font-size: 11px;
                    color: #444d54;
                    position: absolute;
                    top: 13px;
                    left: 122px;
                    background-color: #fff;
                    padding: 0px 5px;
                  }
                  .custom-question-description-label {
                    font-size: 11px;
                    color: #444d54;
                    position: absolute;
                    top: 12px;
                    left: 113px;
                    background-color: transparent;
                    padding: 0px 5px;
                    z-index: 1;
                  }
                  .custom-question-description-label-background {
                    top: 20px;
                    left: 113px;
                    width: 121px;
                    height: 10px;
                    position: absolute;
                    background-color: #fff;
                    z-index: 0;
                  }
                  .custom-question-description-label-background.disabled {
                    background-color: #f4f6f8;
                  }
                  .custom-question-description-label-background.disabled.no-value {
                    background-color:#f4f6f8;
                  }
                  .warning-msg {
                    font-size: 11px;
                    color: #ebafba;
                    position: absolute;
                    left: 100px;
                  }
                  .reminding-msg {
                    font-size: 11px;
                    color: #444d54;
                    position: absolute;
                    left: 100px;
                  }
                  .add-question-title {
                    padding: 30px 0px 0px 0px;
                  }
                  .customer-effort-question {
                    .customer-effort-operator-dropdown.no-value {
                      .el-input__inner {
                        background-color: #fff4f4;
                        border: 1px solid #ebafba;
                      }
                    }
                    .input-customer-effort-value.no-value {
                      background-color: #fff4f4;
                      border: 1px solid #ebafba;
                    }
                  }
                  .options-section {
                    margin-top: 25px;
                    max-width: 985px;
                    .option-title {
                      display: block;
                      padding: 10px 0px;
                      margin-bottom: 5px;
                      .option-body {
                        position: relative;
                        .option-label-title {
                          font-size: 11px;
                          position: absolute;
                          top: -16px;
                        }
                        .option-value-title{
                          font-size: 11px;
                          position: absolute;
                          top: -16px;
                        }
                        .option-auto-fail-title{
                          font-size: 11px;
                          position: absolute;
                          top: -20px;
                          left: 92px;
                        }
                      }
                      .option-label {
                        width: fit-content;
                        margin-right: 15px;
                        input.el-input__inner {
                          border-radius: 5px;
                          width: 220px;
                          border: 1px solid #D2D8DC !important;
                          padding-left: 10px;
                        }
                      }
                      .option-value {
                        width: fit-content;
                        input.el-input__inner {
                          border-radius: 5px;
                          width: 162px;
                          border: 1px solid #D2D8DC !important;
                          padding-left: 10px;
                        }
                      }

                      .vue-numeric.option-value {
                        width: fit-content;
                        height: 36px;
                        line-height: 40px;
                        outline: 0;
                        padding: 0 15px;
                        width: 145px;
                        font-size: 16px;
                        line-height: normal;
                        transition: border-color 0.2s
                          cubic-bezier(0.645, 0.045, 0.355, 1);
                        border: 1px solid #dcdfe6;
                        border-width: 1px !important;
                        border-radius: 5px;
                        padding-left: 10px;
                        // margin-left: 50px;
                        border-color: #d2d8dc;
                        position: relative;
                        // top: 2px;
                        border-radius: 5px;
                        width: 128px;
                        border: 1px solid #D2D8DC !important;
                        padding-left: 10px;
                      }

                      .phrase-match-option-dropdown.option-value {
                        width: fit-content;
                        height: 36px;
                        line-height: 40px;
                        outline: 0;
                        width: 145px;
                        font-size: 16px;
                        line-height: normal;
                        transition: border-color 0.2s
                          cubic-bezier(0.645, 0.045, 0.355, 1);
                        border: 1px solid #dcdfe6;
                        border-width: 1px !important;
                        border-radius: 5px;
                        border-color: #d2d8dc;
                        position: relative;
                        border-radius: 5px;
                        width: 128px;
                        border: 0px solid #D2D8DC !important;

                        .el-input__inner {
                          font-size: 14px;
                          border-width: 1px !important;
                          border-radius: 5px;
                          padding-left: 10px;
                          height: 38px;
                          border-color: #D2D8DC !important;
                          width: 128px;
                          padding-right: 10px;
                        }
                      }

                      .vue-numeric.option-value.no-value {
                        background-color: #fff4f4;
                        border: 1px solid #ebafba;
                      }
                      .vue-numeric.option-value.no-value:focus {
                        border-color: #f03106 !important;
                      }
                      
                      .el-checkbox__input {
                        margin-left: 15px;
                      }
                      span.el-checkbox__label {
                        position: relative;
                      }
                      .el-checkbox:last-of-type {
                        width: 105px;
                        margin-right: 20px;
                        top: 9px;
                      }
                      .option-kpi-section {
                        display: inline-flex;
                        align-items: center;
                        top: 10px;
                        position: absolute;
                        span.label {
                          position: relative;
                          width: 90px;
                          font-size: 14px;
                        }
                        .el-input__inner {
                          font-size: 14px;
                          border-width: 1px !important;
                          border-radius: 5px;
                          padding-left: 10px;
                          height: 38px;
                          border-color: #D2D8DC !important;
                          width: 120px;
                        }
                        .el-select {
                          top: -7px;
                        }
                      }
                    }
                  }
                  .phrase-match {
                    span.label {
                      position: relative;
                      width: 90px;
                      font-size: 14px;
                    }
                    .el-input__inner {
                      font-size: 14px;
                      border-width: 1px !important;
                      border-radius: 5px;
                      padding-left: 10px;
                      height: 38px;
                      border-color: #D2D8DC !important;
                      width: 120px;
                    }
                    .div-phrase-match {
                      margin-top: 10px;
                      display: inline-flex;
                      position: relative;

                      .match-type {
                        margin-right: 20px;
                      }
                      .phrase-match-body {
                        .el-input__inner {
                          width: 300px;
                        }
                      }
                      .phrase-match-type-title {
                        font-size: 11px;
                        position: absolute;
                        top: -15px;
                      }
                      .phrase-match-sent-by-title {
                        font-size: 11px;
                        position: absolute;
                        left: 142px;
                        top: -15px;
                      }
                    }
                    .div-phrase-content {
                      position: relative;
                      .phrase-examples {
                        padding: 15px;
                        margin: 30px 5px 5px 0px;
                        border: 1px solid #CCC;
                        width: 800px;
                        height: 156px;
                        overflow-y: auto;
                        pointer-events: all !important;

                        .el-tag {
                          margin: 5px;
                          background-color: #FAFAFA;
                          border-color: #D9D9D9;
                          color: var(--site-font-primary-color);
                          padding: 0 8px;
                          height: 25px;
                          line-height: 25px;
                          cursor: pointer;
                          .el-tag__close {
                            color: var(--site-font-primary-color);
                          }
                          .el-tag__close:hover {
                            color: #FFF !important;
                            // color: var(--site-font-primary-color);
                            background-color: #989c9f;
                          }
                        }
                        .el-tag.disabled {
                          pointer-events: none !important;
                          opacity: 0.5;
                        }
                        .el-tag.duplicate-phrase {
                          color: #FA8C16;
                          background-color: #FFF7E6;
                          border-color: #FA8C16;
                          .el-tag__close:hover {
                            color: #FFF7E6 !important;
                            background-color: #FA8C16;
                          }
                        }
                        .el-tag.phrase-match-tag-update {
                          color: #409EFF;
                          border-color: #c6e2ff;
                          background-color: #ecf5ff;
                          .el-tag__close:hover {
                            background-color: #409EFF;
                          }
                        }
                        .button-new-tag {
                          height: 25px;
                          padding: 0 10px;
                          line-height: 23px;
                          font-size: 12px;
                          border-width: 1px;
                          border-style: dashed;
                          border-radius: 4px;
                        }
                        .input-new-tag {
                          width: fit-content;
                          visibility: hidden;

                          .el-input__inner {
                            height: 25px;
                            line-height: 25px;
                            font-size: 12px;
                            border-radius: 4px;
                            padding: 0 10px;
                            // width: unset;
                            box-sizing: border-box;
                            width: 10em;
                          }
                          .el-input__suffix-inner {
                            pointer-events: none !important;
                          }
                        }
                      }
                      .phrase-match-title {
                        font-size: 11px;
                        position: absolute;
                        top: -15px;
                      }
                    }
                    
                    .btn-add-phrase {
                      display: block;
                      cursor: pointer;
                      margin-right: 10px;
                      border: 0px;
                      color: #fff;
                      -webkit-box-shadow: none;
                      box-shadow: none;
                      background-color: #1890ff;
                      border-radius: 5px;
                      font-weight: 600;
                      width: 120px;
                      height: 32px;
                    }
                    .question-dropdown.no-value {
                      .el-input__inner {
                        background-color: #fff4f4;
                        border: 1px solid #ebafba;
                      }
                    }
                  }
                  .answer-content {
                    display: none;
                    margin-top: 30px;
                    .btn-add-answer {
                      cursor: pointer;
                      margin-right: 10px;
                      border: 0px;
                      color: #fff;
                      box-shadow: none;
                      background-color: #1890ff;
                      border-radius: 5px;
                      font-weight: 600;
                      width: 150px;
                      height: 32px;
                    }
                    .div-add-answer-btn {
                      margin-top: 15px;
                    }
                  }

                  .customer-effort-question {
                    padding-top: 30px;
                    position: relative;
                    display: flex;
                    align-items: center;
                    .customer-effort-option-label {
                      font-weight: 700;
                    }
                    .customer-effort-operator-title {
                      font-size: 11px;
                      position: relative;
                      right: 263px;
                      top: -30px;
                    }
                    .threshold-section {
                      position: relative;
                      width: 400px;
                      .customer-effort-threshold-des {
                        font-size: 11px;
                        position: absolute;
                        left: 10px;
                        top: 41px;
                      }
                      .customer-effort-threshold-title {
                        font-size: 11px;
                        position: absolute;
                        left: 11px;
                        top: -15px;
                      }
                    }
                    .customer-effort-operator-dropdown {
                      margin-left: 20px;
                      // margin-right: 10px;
                      width: 65px;
                      .el-input--mini .el-input__inner {
                        font-size: 14px;
                        border-width: 1px !important;
                        border-radius: 5px;
                        padding-left: 10px;
                        height: 40px;
                        border-color: #d2d8dc !important;
                      }
                      .el-select__caret {
                        color: #1b1f22;
                      }
                    }
                    .input-customer-effort-value {
                      height: 37px;
                      outline: 0;
                      padding: 0 15px;
                      width: 238px;
                      font-size: 16px;
                      line-height: normal;
                      transition: border-color 0.2s
                        cubic-bezier(0.645, 0.045, 0.355, 1);
                      border: 1px solid #dcdfe6;
                      border-width: 1px !important;
                      border-radius: 5px;
                      padding-left: 10px;
                      border-color: #d2d8dc;
                      margin-left: 10px;
                    }
                  }
                }
              }
            }
          }
        }
        .btn-move-section,
        .btn-move-question {
          height: 36px;
          padding: 4px 8px;
          position: relative;
          top: 3px;
          cursor: pointer;
          border-radius: 5px;
          background-color: #fff;
          border: 1px solid #d9d9d9;
          margin-right: 12px;
          box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
          .el-icon-arrow-up,
          .el-icon-arrow-down {
            font-size: 20px;
          }
          .el-icon-arrow-up:before {
            color: #8c8c8c;
          }
          .el-icon-arrow-down:before {
            color: #8c8c8c;
          }
        }
        .btn-move-section:disabled,
        .btn-move-question:disabled {
          opacity: 0.5;
          cursor: not-allowed !important;
        }
        .section-blank-space {
          width: 15px;
        }
        .question-blank-space {
          width: 0px;
        }

        .vue-numeric.no-value {
          background-color: #fff4f4;
          border: 1px solid #ebafba !important;
        }
      }
    }
    .section-question {
      .slider {
        width: 350px;
        .slider-block {
          width: 350px;
          position: relative;
          .el-slider {
            width: 350px;
            padding: 30px 0px;
            .el-slider__runway {
              height: 2px;
              background-color: #dcdfe6;
              .el-slider__bar {
                height: 2px;
                background-color: #91D5FF;
              }
              .el-slider__button-wrapper {
                height: 6px;
                width: 6px;
                top: -10px;
                z-index: 100;
                .el-slider__button {
                  width: 10px;
                  height:10px;
                  border: 2px solid #91D5FF;
                  // border: 1px solid #0b2b3b;
                  // background-color: #0b2b3b;
                }
              }
            }
          }
          .sphere {
            height: 25px;
            width: 25px;
            border-radius: 0 50% 50% 50%;
            text-align: center;
            vertical-align: middle;
            position: absolute;
            display: inline-block;
            transform:rotate(225deg);
            background:transparent;
            div.text-value {
              position: relative;
              transform: rotate(135deg);
              color: #000;
              left: 0px;
              top: 6px;
              font-weight: 500;
              font-size: 11px;
            }
          }
          .target-start {
            color: #919191;
            left: 0px;
            top: 20px;
            font-weight: 500;
            font-size: 11px;
            position: absolute;
          }
          .target-end {
            color: #919191;
            left: 344px;
            top: 20px;
            font-weight: 500;
            font-size: 11px;
            position: absolute;
          }
          // .sphere.button1 {
          //   background-image: var(--form-editor-target-icon);
          //   background-repeat: no-repeat;
            
          // }
          .target_2 {
            height: 25px;
            width: 25px;
            position: absolute;
            background-image: var(--form-editor-target-icon);
            background-repeat: no-repeat;
          }
        }
      }
      .target-title {
        padding-top: 10px;
        padding-bottom: 20px;
        font-size: 14px;
      }
      .target-des {
        font-size: 14px;
        margin-bottom: 25px;
       
        .target-item {
          width: 530px;
          display: inline-flex;
        }
        span.value {
          font-weight: 700;
          width: 80px;
          display: flex;
          align-items: center;
        }
        .text-input.form-target.empty {
          input.el-input__inner {
            border: 1px solid #ebafba !important;
            background-color: #fff4f4;
          }
        }
        input.el-input__inner {
          font-size: 16px;
          border-width: 1px !important;
          border-radius: 5px;
          padding-left: 10px;
          border-color: #d2d8dc;
          width: 450px;
        }
        .el-input__count .el-input__count-inner {
          position: relative;
          top: 30px;
        }
      }
    }
   
    .add-section-title {
      padding: 30px 0px 0px 0px;
    }
    .div-add-section-btn {
      padding: 20px 0px 40px 0px;
      .btn-add-section {
        cursor: pointer;
        margin-right: 10px;
        border: 0px;
        color: #fff;
        box-shadow: none;
        background-color: #1890ff;
        border-radius: 5px;
        font-weight: 600;
        width: 150px;
        height: 32px;
      }
      .btn-balance-section-weight {
        cursor: pointer;
        margin-right: 10px;
        border: 0px;
        color: #1b1f22;
        -webkit-box-shadow: none;
        box-shadow: none;
        background-color: #bfbfbf;
        border-radius: 5px;
        font-weight: 400;
        width: 215px;
        height: 32px;
        margin-right: 50px;
      }
      .section-weight-percentage {
        font-size: 24px;
        font-weight: 700;
        position: relative;
        top: 5px;
        .el-icon-weight-info {
          position: relative;
          background-image: var(--header-icon-elv-form-weight-pass);
          background-repeat: no-repeat;
          background-size: 24px;
          width: 24px;
          height: 24px;
          top: 3px;
          left: 10px;
        }
      }
      .section-weight-percentage.red {
        color: #a6182d;
        .el-icon-weight-info {
          background-image: var(--header-icon-elv-form-weight-warning);
        }
      }
    }
  }
  .new-form-body {
    .form-des-warning-msg {
      font-size: 11px;
      color: #ebafba;
      position: absolute;
      top: 186px;
      left: 40px;
    }
    .form-des-reminding-msg {
      font-size: 11px;
      color: #444d54;
      position: absolute;
      top: 186px;
      left: 40px;
    }
    .div-form-ai-evaluation-instructions {
      .form-ai-evaluation-instructions-warning-msg {
        font-size: 11px;
        color: #ebafba;
        position: absolute;
        top: 136px;
        left: 0px;
      }
      .form-ai-evaluation-instructions-reminding-msg {
        font-size: 11px;
        color: #444d54;
        position: absolute;
        top: 136px;
        left: 0px;
      }
    }
  }
  .el-loading-mask {
    background-color: #fff !important;
    position: fixed;
    .el-loading-spinner {
      top: 45% !important;
      margin-top: 0px;
      background: var(--site-loading-icon);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: center;
      .circular {
        display: inline-block;
        width: 90px;
        height: 90px;
      }
    }
  }

  .popup-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .popup-body {
    margin-top: -130px;
    background: white;
    display: flex;
    flex-direction: column;
    max-height: calc(100% - 64px);
    max-width: 600px;
    border-radius: 4px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
      0px 24px 38px 3px rgba(0, 0, 0, 0.14),
      0px 9px 46px 8px rgba(0, 0, 0, 0.12);

    .title {
      font-size: 1.25rem;
      font-weight: 600;
      line-height: 1.6;
      letter-spacing: 0.0075em;
      padding: 16px 24px;
      text-align: left;
    }
    .desc {
      color: rgba(0, 0, 0, 0.54);
      padding: 8px 24px;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      letter-spacing: 0.00938em;
      margin-bottom: 12px;
      text-align: left;
    }
    .footer {
      padding: 8px;
      display: flex;
      justify-content: flex-end;
      .el-button {
        border-radius: 4px !important;
        padding: 12px 16px !important;
        background-color: #193b5c;
        border: none;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
          0px 2px 2px 0px rgba(0, 0, 0, 0.14),
          0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
    }
    .el-button {
      font-weight: 600 !important;
      width: 64px;
    }
    .no-action {
      background: #e0e0e0 !important;
      color: black !important;
    }
  }
}
// @media screen and (min-width: 1800px) {
//   .wy-evaluation-new-form {
//     margin: 0px 2%;
//   }
// }
.el-dropdown-menu.elv-form-question-menu {
  min-width: 190px;
}
.elv-form-question-menu,
.wy-auto-qa-elv-form-category-questions {
  .el-dropdown-menu__item {
    color: #003b5c;
  }

  .el-select-dropdown__item.selected {
    color: #006fe7;
    font-weight: 400;
  }
  .el-dropdown-menu__item:hover {
    background-color: rgba(0, 59, 92, 0.04);
    color: #003b5c;
  }
  .popper__arrow {
    display: none;
  }
}

.elv-form-question-menu,
.wy-auto-qa-elv-form-category-questions.questions {
  .el-select-dropdown__item.selected {
    display: block !important;
  }
  .el-select-dropdown__item.is-disabled {
    display: none;
  }
}

.el-message.evaluation-form-duplicate-name-warning-msg,
.el-message.evaluation-form-internal-error-warning-msg,
.evaluation-form-publish-warning-msg {
  background-color: #a6182d;
  padding: 15px 35px 15px 20px;
  .el-icon-info {
    display: none;
  }
  .el-message__content {
    padding-right: 50px;
    font-weight: 700;
    color: #fff;
  }
  .el-message__closeBtn {
    color: #fff;
    font-size: 20px;
    font-weight: 700;
  }
}

.el-message.evaluation-form-save-success-msg {
  background-color: #4caf50;
  .el-icon-info {
    display: none;
  }
  .el-message__content {
    padding-right: 50px;
    font-weight: 700;
    color: #fff;
  }
  .el-message__closeBtn {
    color: #fff;
    font-size: 20px;
    font-weight: 700;
  }
}

.elv-form-question-menu,
.wy-auto-qa-elv-form-category-questions.options-operator {
  .el-select-dropdown__item.selected {
    color: #006fe7;
    font-weight: 400;
  }
}

.wy-auto-qa-elv-form-questions-options-auto-fail-level {
  .el-select-dropdown__item.selected {
    color: #006FE7;
    font-weight: 400;
  }
}

.wy-auto-qa-elv-form-questions-phrase-match-sent-by,.wy-auto-qa-elv-form-questions-phrase-match-match-type {
  .el-select-dropdown__item.selected {
    color: #006FE7;
    font-weight: 400;
  }
}

.el-dialog__wrapper {
  .el-dialog.evl-form-dialog-modal {
    width: 600px !important;
    height: 192px;
    .el-dialog__title {
      font-size: 20x;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 500;
      line-height: 1.6;
    }
    .el-dialog__body {
      padding: 25px 20px;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .dialog-footer {
      button {
        margin-right: 10px;
        border: 0px;
        box-shadow: none;
        border-radius: 2px;
        font-weight: 400;
        color: #000;
        background-color: #fff;
        border: 1px solid #d9d9d9;
      }
      button:disabled {
        color: rgba(0, 0, 0, 0.26);
        background-color: rgba(0, 0, 0, 0.12);
        cursor: not-allowed;
      }
      .btn-dialog-cancel {
        cursor: pointer;
        width: 82px;
      }
      .btn-dialog-confirm {
        cursor: pointer;
        width: 82px;
        float: right;
      }
    }
  }
}
.el-container.read-only {
  .question-body .question-header {
    .question-weight-label,
    .question-weight-label-background {
      left: 725px !important;
      right: 45px !important;
    }

    .question-weight-label {
      right: 45px !important;
    }
  }
  .question-description-label {
    left: 22px !important;
  }
  .category-title {
    left: 2px !important;
  }
  .question-title {
    left: 162px !important;
  }
}
.form-editor-target-range-tooltip.el-tooltip__popper.is-dark {
  background-color: #0b2b3b !important;
    display: flex !important;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 12px;
    width: 12px;
    border-radius: 0 50% 50% 50%;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    margin: 0% 0% 40px 23px;
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  span {
    position: relative;
    left: 0px;
    transform: rotate(135deg);
  }
  .popper__arrow {
    top: 2px !important;
    left: 10px !important;
  }
}
.wy-evaluation-form-editor-form-description-popper {
  max-width: 576px;
  font-size: 11.2px;
}

</style>
